var _defs, _rect, _image, _path, _path2, _path3, _image2, _path4, _image3, _path5, _g, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _path12, _path13, _path14, _polygon2, _polygon3, _polygon4, _g2, _polygon5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon6, _path22, _path23, _polygon7, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g3, _path36, _path37, _path38, _path39, _path40, _polygon8, _path41, _path42, _path43, _path44, _polygon9, _polygon10, _polygon11, _g4, _polygon12, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon13, _path52, _path53, _polygon14, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13S(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.57 235.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3{fill:#231f20;}.cls-10,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-12,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-14,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-16,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-17,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-18,.cls-187,.cls-188,.cls-189,.cls-19,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-20,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-21,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-22,.cls-220,.cls-221,.cls-222,.cls-223,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-23,.cls-230,.cls-231,.cls-232,.cls-233,.cls-234,.cls-235,.cls-236,.cls-237,.cls-238,.cls-239,.cls-24,.cls-240,.cls-241,.cls-242,.cls-243,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-25,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-26,.cls-260,.cls-261,.cls-262,.cls-263,.cls-264,.cls-265,.cls-266,.cls-27,.cls-271,.cls-272,.cls-273,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-28,.cls-280,.cls-281,.cls-282,.cls-283,.cls-284,.cls-285,.cls-286,.cls-287,.cls-288,.cls-289,.cls-29,.cls-290,.cls-291,.cls-292,.cls-293,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-3,.cls-30,.cls-300,.cls-301,.cls-302,.cls-303,.cls-304,.cls-305,.cls-306,.cls-307,.cls-308,.cls-309,.cls-31,.cls-310,.cls-311,.cls-312,.cls-313,.cls-314,.cls-315,.cls-316,.cls-317,.cls-318,.cls-319,.cls-32,.cls-320,.cls-321,.cls-322,.cls-323,.cls-324,.cls-325,.cls-326,.cls-327,.cls-328,.cls-329,.cls-33,.cls-330,.cls-331,.cls-332,.cls-333,.cls-334,.cls-335,.cls-336,.cls-337,.cls-338,.cls-339,.cls-34,.cls-340,.cls-341,.cls-342,.cls-343,.cls-344,.cls-345,.cls-346,.cls-347,.cls-348,.cls-349,.cls-35,.cls-350,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-7,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-8,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-9,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill-rule:evenodd;}.cls-4{fill:url(#linear-gradient);}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#linear-gradient-13);}.cls-18{fill:url(#linear-gradient-14);}.cls-19{fill:url(#linear-gradient-15);}.cls-20{fill:url(#linear-gradient-16);}.cls-21{fill:url(#linear-gradient-17);}.cls-22{fill:url(#linear-gradient-18);}.cls-23{fill:url(#linear-gradient-19);}.cls-24{fill:url(#linear-gradient-20);}.cls-25{fill:url(#linear-gradient-21);}.cls-26{fill:url(#linear-gradient-22);}.cls-27{fill:url(#linear-gradient-23);}.cls-28{fill:url(#linear-gradient-24);}.cls-29{fill:url(#linear-gradient-25);}.cls-30{fill:url(#linear-gradient-26);}.cls-31{fill:url(#linear-gradient-27);}.cls-32{fill:url(#linear-gradient-28);}.cls-33{fill:url(#linear-gradient-29);}.cls-34{fill:url(#linear-gradient-30);}.cls-35{fill:url(#linear-gradient-31);}.cls-36{fill:url(#linear-gradient-32);}.cls-37{fill:url(#linear-gradient-33);}.cls-38{fill:url(#linear-gradient-34);}.cls-39{fill:url(#linear-gradient-35);}.cls-40{fill:url(#linear-gradient-36);}.cls-41{fill:url(#linear-gradient-37);}.cls-42{fill:url(#linear-gradient-38);}.cls-43{fill:url(#linear-gradient-39);}.cls-44{fill:url(#linear-gradient-40);}.cls-45{fill:url(#linear-gradient-41);}.cls-46{fill:url(#linear-gradient-42);}.cls-47{fill:url(#linear-gradient-43);}.cls-48{fill:url(#linear-gradient-44);}.cls-49{fill:url(#linear-gradient-45);}.cls-50{fill:url(#linear-gradient-46);}.cls-51{fill:url(#linear-gradient-47);}.cls-52{fill:url(#linear-gradient-48);}.cls-53{fill:url(#linear-gradient-49);}.cls-54{fill:url(#linear-gradient-50);}.cls-55{fill:url(#linear-gradient-51);}.cls-56{fill:url(#linear-gradient-52);}.cls-57{fill:url(#linear-gradient-53);}.cls-58{fill:url(#linear-gradient-54);}.cls-59{fill:url(#linear-gradient-55);}.cls-60{fill:url(#linear-gradient-56);}.cls-61{fill:url(#linear-gradient-57);}.cls-62{fill:url(#linear-gradient-58);}.cls-63{fill:url(#linear-gradient-59);}.cls-64{fill:url(#linear-gradient-60);}.cls-65{fill:url(#linear-gradient-61);}.cls-66{fill:url(#linear-gradient-62);}.cls-67{fill:url(#linear-gradient-63);}.cls-68{fill:url(#linear-gradient-64);}.cls-69{fill:url(#linear-gradient-65);}.cls-70{fill:url(#linear-gradient-66);}.cls-71{fill:url(#linear-gradient-67);}.cls-72{fill:url(#linear-gradient-68);}.cls-73{fill:url(#linear-gradient-69);}.cls-74{fill:url(#linear-gradient-70);}.cls-75{fill:url(#linear-gradient-71);}.cls-76{fill:url(#linear-gradient-72);}.cls-77{fill:url(#linear-gradient-73);}.cls-78{fill:url(#linear-gradient-74);}.cls-79{fill:url(#linear-gradient-75);}.cls-80{fill:url(#linear-gradient-76);}.cls-81{fill:url(#linear-gradient-77);}.cls-82{fill:url(#linear-gradient-78);}.cls-83{fill:url(#linear-gradient-79);}.cls-84{fill:url(#linear-gradient-80);}.cls-85{fill:url(#linear-gradient-81);}.cls-86{fill:url(#linear-gradient-82);}.cls-87{fill:#fde4e0;}.cls-88{fill:#bc9133;}.cls-89{fill:#f2c76c;}.cls-90{fill:url(#linear-gradient-83);}.cls-91{fill:#dadbdc;}.cls-92{fill:url(#linear-gradient-84);}.cls-93{fill:#fff;}.cls-94{clip-path:url(#clip-path-2);}.cls-95{fill:url(#linear-gradient-85);}.cls-96{fill:url(#linear-gradient-86);}.cls-97{fill:url(#linear-gradient-87);}.cls-98{fill:url(#linear-gradient-88);}.cls-99{fill:url(#linear-gradient-89);}.cls-100{fill:url(#linear-gradient-90);}.cls-101{fill:url(#linear-gradient-91);}.cls-102{fill:url(#linear-gradient-92);}.cls-103{fill:url(#linear-gradient-93);}.cls-104{fill:url(#linear-gradient-94);}.cls-105{fill:url(#linear-gradient-95);}.cls-106{fill:url(#linear-gradient-96);}.cls-107{fill:url(#linear-gradient-97);}.cls-108{fill:url(#linear-gradient-98);}.cls-109{fill:url(#linear-gradient-99);}.cls-110{fill:url(#linear-gradient-100);}.cls-111{fill:url(#linear-gradient-101);}.cls-112{fill:url(#linear-gradient-102);}.cls-113{fill:url(#linear-gradient-103);}.cls-114{fill:url(#linear-gradient-104);}.cls-115{fill:url(#linear-gradient-105);}.cls-116{fill:url(#linear-gradient-106);}.cls-117{fill:url(#linear-gradient-107);}.cls-118{fill:url(#linear-gradient-108);}.cls-119{fill:url(#linear-gradient-109);}.cls-120{fill:url(#linear-gradient-110);}.cls-121{fill:url(#linear-gradient-111);}.cls-122{fill:url(#linear-gradient-112);}.cls-123{fill:url(#linear-gradient-113);}.cls-124{fill:url(#linear-gradient-114);}.cls-125{fill:url(#linear-gradient-115);}.cls-126{fill:url(#linear-gradient-116);}.cls-127{fill:url(#linear-gradient-117);}.cls-128{fill:url(#linear-gradient-118);}.cls-129{fill:url(#linear-gradient-119);}.cls-130{fill:url(#linear-gradient-120);}.cls-131{fill:url(#linear-gradient-121);}.cls-132{fill:url(#linear-gradient-122);}.cls-133{fill:url(#linear-gradient-123);}.cls-134{fill:url(#linear-gradient-124);}.cls-135{fill:url(#linear-gradient-125);}.cls-136{fill:url(#linear-gradient-126);}.cls-137{fill:url(#linear-gradient-127);}.cls-138{fill:url(#linear-gradient-128);}.cls-139{fill:url(#linear-gradient-129);}.cls-140{fill:url(#linear-gradient-130);}.cls-141{fill:url(#linear-gradient-131);}.cls-142{fill:url(#linear-gradient-132);}.cls-143{fill:url(#linear-gradient-133);}.cls-144{fill:url(#linear-gradient-134);}.cls-145{fill:url(#linear-gradient-135);}.cls-146{fill:url(#linear-gradient-136);}.cls-147{fill:url(#linear-gradient-137);}.cls-148{fill:url(#linear-gradient-138);}.cls-149{fill:url(#linear-gradient-139);}.cls-150{fill:url(#linear-gradient-140);}.cls-151{fill:url(#linear-gradient-141);}.cls-152{fill:url(#linear-gradient-142);}.cls-153{fill:url(#linear-gradient-143);}.cls-154{fill:url(#linear-gradient-144);}.cls-155{fill:url(#linear-gradient-145);}.cls-156{fill:url(#linear-gradient-146);}.cls-157{fill:url(#linear-gradient-147);}.cls-158{fill:url(#linear-gradient-148);}.cls-159{fill:url(#linear-gradient-149);}.cls-160{fill:url(#linear-gradient-150);}.cls-161{fill:url(#linear-gradient-151);}.cls-162{fill:url(#linear-gradient-152);}.cls-163{fill:url(#linear-gradient-153);}.cls-164{fill:url(#linear-gradient-154);}.cls-165{fill:url(#linear-gradient-155);}.cls-166{fill:url(#linear-gradient-156);}.cls-167{fill:url(#linear-gradient-157);}.cls-168{fill:url(#linear-gradient-158);}.cls-169{fill:url(#linear-gradient-159);}.cls-170{fill:url(#linear-gradient-160);}.cls-171{fill:url(#linear-gradient-161);}.cls-172{fill:url(#linear-gradient-162);}.cls-173{fill:url(#linear-gradient-163);}.cls-174{fill:url(#linear-gradient-164);}.cls-175{fill:#a3a5a8;}.cls-176{fill:#fbcfc7;}.cls-177{fill:url(#linear-gradient-165);}.cls-178{fill:url(#linear-gradient-166);}.cls-179{fill:url(#linear-gradient-167);}.cls-180{fill:url(#linear-gradient-168);}.cls-181{fill:url(#linear-gradient-169);}.cls-182{fill:url(#linear-gradient-170);}.cls-183{fill:url(#linear-gradient-171);}.cls-184{fill:url(#linear-gradient-172);}.cls-185{fill:url(#linear-gradient-173);}.cls-186{clip-path:url(#clip-path-3);}.cls-187{fill:url(#linear-gradient-174);}.cls-188{fill:url(#linear-gradient-175);}.cls-189{fill:url(#linear-gradient-176);}.cls-190{fill:url(#linear-gradient-177);}.cls-191{fill:url(#linear-gradient-178);}.cls-192{fill:url(#linear-gradient-179);}.cls-193{fill:url(#linear-gradient-180);}.cls-194{fill:url(#linear-gradient-181);}.cls-195{fill:url(#linear-gradient-182);}.cls-196{fill:url(#linear-gradient-183);}.cls-197{fill:url(#linear-gradient-184);}.cls-198{fill:url(#linear-gradient-185);}.cls-199{fill:url(#linear-gradient-186);}.cls-200{fill:url(#linear-gradient-187);}.cls-201{fill:url(#linear-gradient-188);}.cls-202{fill:url(#linear-gradient-189);}.cls-203{fill:url(#linear-gradient-190);}.cls-204{fill:url(#linear-gradient-191);}.cls-205{fill:url(#linear-gradient-192);}.cls-206{fill:url(#linear-gradient-193);}.cls-207{fill:url(#linear-gradient-194);}.cls-208{fill:url(#linear-gradient-195);}.cls-209{fill:url(#linear-gradient-196);}.cls-210{fill:url(#linear-gradient-197);}.cls-211{fill:url(#linear-gradient-198);}.cls-212{fill:url(#linear-gradient-199);}.cls-213{fill:url(#linear-gradient-200);}.cls-214{fill:url(#linear-gradient-201);}.cls-215{fill:url(#linear-gradient-202);}.cls-216{fill:url(#linear-gradient-203);}.cls-217{fill:url(#linear-gradient-204);}.cls-218{fill:url(#linear-gradient-205);}.cls-219{fill:url(#linear-gradient-206);}.cls-220{fill:url(#linear-gradient-207);}.cls-221{fill:url(#linear-gradient-208);}.cls-222{fill:url(#linear-gradient-209);}.cls-223{fill:url(#linear-gradient-210);}.cls-224{fill:url(#linear-gradient-211);}.cls-225{fill:url(#linear-gradient-212);}.cls-226{fill:url(#linear-gradient-213);}.cls-227{fill:url(#linear-gradient-214);}.cls-228{fill:url(#linear-gradient-215);}.cls-229{fill:url(#linear-gradient-216);}.cls-230{fill:url(#linear-gradient-217);}.cls-231{fill:url(#linear-gradient-218);}.cls-232{fill:url(#linear-gradient-219);}.cls-233{fill:url(#linear-gradient-220);}.cls-234{fill:url(#linear-gradient-221);}.cls-235{fill:url(#linear-gradient-222);}.cls-236{fill:url(#linear-gradient-223);}.cls-237{fill:url(#linear-gradient-224);}.cls-238{fill:url(#linear-gradient-225);}.cls-239{fill:url(#linear-gradient-226);}.cls-240{fill:url(#linear-gradient-227);}.cls-241{fill:url(#linear-gradient-228);}.cls-242{fill:url(#linear-gradient-229);}.cls-243{fill:url(#linear-gradient-230);}.cls-244{fill:url(#linear-gradient-231);}.cls-245{fill:url(#linear-gradient-232);}.cls-246{fill:url(#linear-gradient-233);}.cls-247{fill:url(#linear-gradient-234);}.cls-248{fill:url(#linear-gradient-235);}.cls-249{fill:url(#linear-gradient-236);}.cls-250{fill:url(#linear-gradient-237);}.cls-251{fill:url(#linear-gradient-238);}.cls-252{fill:url(#linear-gradient-239);}.cls-253{fill:url(#linear-gradient-240);}.cls-254{fill:url(#linear-gradient-241);}.cls-255{fill:url(#linear-gradient-242);}.cls-256{fill:url(#linear-gradient-243);}.cls-257{fill:url(#linear-gradient-244);}.cls-258{fill:url(#linear-gradient-245);}.cls-259{fill:url(#linear-gradient-246);}.cls-260{fill:url(#linear-gradient-247);}.cls-261{fill:url(#linear-gradient-248);}.cls-262{fill:url(#linear-gradient-249);}.cls-263{fill:url(#linear-gradient-250);}.cls-264{fill:url(#linear-gradient-251);}.cls-265{fill:url(#linear-gradient-252);}.cls-266{fill:url(#linear-gradient-253);}.cls-267{fill:url(#linear-gradient-254);}.cls-268{fill:url(#linear-gradient-255);}.cls-269{fill:url(#linear-gradient-256);}.cls-270{clip-path:url(#clip-path-4);}.cls-271{fill:url(#linear-gradient-257);}.cls-272{fill:url(#linear-gradient-258);}.cls-273{fill:url(#linear-gradient-259);}.cls-274{fill:url(#linear-gradient-260);}.cls-275{fill:url(#linear-gradient-261);}.cls-276{fill:url(#linear-gradient-262);}.cls-277{fill:url(#linear-gradient-263);}.cls-278{fill:url(#linear-gradient-264);}.cls-279{fill:url(#linear-gradient-265);}.cls-280{fill:url(#linear-gradient-266);}.cls-281{fill:url(#linear-gradient-267);}.cls-282{fill:url(#linear-gradient-268);}.cls-283{fill:url(#linear-gradient-269);}.cls-284{fill:url(#linear-gradient-270);}.cls-285{fill:url(#linear-gradient-271);}.cls-286{fill:url(#linear-gradient-272);}.cls-287{fill:url(#linear-gradient-273);}.cls-288{fill:url(#linear-gradient-274);}.cls-289{fill:url(#linear-gradient-275);}.cls-290{fill:url(#linear-gradient-276);}.cls-291{fill:url(#linear-gradient-277);}.cls-292{fill:url(#linear-gradient-278);}.cls-293{fill:url(#linear-gradient-279);}.cls-294{fill:url(#linear-gradient-280);}.cls-295{fill:url(#linear-gradient-281);}.cls-296{fill:url(#linear-gradient-282);}.cls-297{fill:url(#linear-gradient-283);}.cls-298{fill:url(#linear-gradient-284);}.cls-299{fill:url(#linear-gradient-285);}.cls-300{fill:url(#linear-gradient-286);}.cls-301{fill:url(#linear-gradient-287);}.cls-302{fill:url(#linear-gradient-288);}.cls-303{fill:url(#linear-gradient-289);}.cls-304{fill:url(#linear-gradient-290);}.cls-305{fill:url(#linear-gradient-291);}.cls-306{fill:url(#linear-gradient-292);}.cls-307{fill:url(#linear-gradient-293);}.cls-308{fill:url(#linear-gradient-294);}.cls-309{fill:url(#linear-gradient-295);}.cls-310{fill:url(#linear-gradient-296);}.cls-311{fill:url(#linear-gradient-297);}.cls-312{fill:url(#linear-gradient-298);}.cls-313{fill:url(#linear-gradient-299);}.cls-314{fill:url(#linear-gradient-300);}.cls-315{fill:url(#linear-gradient-301);}.cls-316{fill:url(#linear-gradient-302);}.cls-317{fill:url(#linear-gradient-303);}.cls-318{fill:url(#linear-gradient-304);}.cls-319{fill:url(#linear-gradient-305);}.cls-320{fill:url(#linear-gradient-306);}.cls-321{fill:url(#linear-gradient-307);}.cls-322{fill:url(#linear-gradient-308);}.cls-323{fill:url(#linear-gradient-309);}.cls-324{fill:url(#linear-gradient-310);}.cls-325{fill:url(#linear-gradient-311);}.cls-326{fill:url(#linear-gradient-312);}.cls-327{fill:url(#linear-gradient-313);}.cls-328{fill:url(#linear-gradient-314);}.cls-329{fill:url(#linear-gradient-315);}.cls-330{fill:url(#linear-gradient-316);}.cls-331{fill:url(#linear-gradient-317);}.cls-332{fill:url(#linear-gradient-318);}.cls-333{fill:url(#linear-gradient-319);}.cls-334{fill:url(#linear-gradient-320);}.cls-335{fill:url(#linear-gradient-321);}.cls-336{fill:url(#linear-gradient-322);}.cls-337{fill:url(#linear-gradient-323);}.cls-338{fill:url(#linear-gradient-324);}.cls-339{fill:url(#linear-gradient-325);}.cls-340{fill:url(#linear-gradient-326);}.cls-341{fill:url(#linear-gradient-327);}.cls-342{fill:url(#linear-gradient-328);}.cls-343{fill:url(#linear-gradient-329);}.cls-344{fill:url(#linear-gradient-330);}.cls-345{fill:url(#linear-gradient-331);}.cls-346{fill:url(#linear-gradient-332);}.cls-347{fill:url(#linear-gradient-333);}.cls-348{fill:url(#linear-gradient-334);}.cls-349{fill:url(#linear-gradient-335);}.cls-350{fill:url(#linear-gradient-336);}.cls-351{fill:url(#linear-gradient-337);}.cls-352{fill:url(#linear-gradient-338);}.cls-353{fill:url(#linear-gradient-339);}.cls-354{fill:url(#linear-gradient-340);}.cls-355{fill:url(#linear-gradient-341);}.cls-356{fill:url(#linear-gradient-342);}.cls-357{fill:url(#linear-gradient-343);}.cls-358{fill:url(#linear-gradient-344);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 95.94,
    y1: 60.37,
    x2: 74.61,
    y2: 127.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.65,72.47,38.28,77.83s-5.61.54-5.61,7.23v25.72l99.6,11.52s-25.12-37.5-33-44.2c-.88-.75-4.92-1.64-9.88-2.48C79.78,74,66.65,72.47,66.65,72.47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 36.71,
    y1: 63.71,
    x2: 103.71,
    y2: 134.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 44.04,
    y1: 56.79,
    x2: 111.04,
    y2: 127.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 22.04,
    y1: 77.55,
    x2: 89.05,
    y2: 148.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 29.38,
    y1: 70.63,
    x2: 96.38,
    y2: 141.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 65.93,
    y1: 36.13,
    x2: 132.93,
    y2: 107.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 73.26,
    y1: 29.21,
    x2: 140.26,
    y2: 100.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 51.27,
    y1: 49.97,
    x2: 118.26,
    y2: 120.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 58.6,
    y1: 43.05,
    x2: 125.6,
    y2: 114.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 36,
    y1: 64.38,
    x2: 102.99,
    y2: 135.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 43.33,
    y1: 57.46,
    x2: 110.33,
    y2: 128.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 21.33,
    y1: 78.22,
    x2: 88.33,
    y2: 149.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 28.66,
    y1: 71.3,
    x2: 95.67,
    y2: 142.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 65.22,
    y1: 36.81,
    x2: 132.22,
    y2: 107.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 72.55,
    y1: 29.89,
    x2: 139.55,
    y2: 100.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 50.55,
    y1: 50.65,
    x2: 117.55,
    y2: 121.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 57.88,
    y1: 43.73,
    x2: 124.88,
    y2: 114.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 30.61,
    y1: 69.46,
    x2: 97.61,
    y2: 140.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 37.95,
    y1: 62.54,
    x2: 104.94,
    y2: 133.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 15.95,
    y1: 83.3,
    x2: 82.94,
    y2: 154.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 23.28,
    y1: 76.38,
    x2: 90.28,
    y2: 147.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 59.83,
    y1: 41.89,
    x2: 126.83,
    y2: 112.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 67.17,
    y1: 34.97,
    x2: 134.16,
    y2: 105.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 45.17,
    y1: 55.73,
    x2: 112.16,
    y2: 126.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 52.5,
    y1: 48.81,
    x2: 119.5,
    y2: 119.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 31.32,
    y1: 68.79,
    x2: 98.32,
    y2: 139.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 38.66,
    y1: 61.87,
    x2: 105.66,
    y2: 132.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 16.66,
    y1: 82.63,
    x2: 83.66,
    y2: 153.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 23.99,
    y1: 75.71,
    x2: 90.99,
    y2: 146.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 60.54,
    y1: 41.22,
    x2: 127.54,
    y2: 112.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 67.88,
    y1: 34.3,
    x2: 134.87,
    y2: 105.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 45.88,
    y1: 55.06,
    x2: 112.88,
    y2: 126.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 53.21,
    y1: 48.13,
    x2: 120.21,
    y2: 119.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 25.22,
    y1: 74.54,
    x2: 92.23,
    y2: 145.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 32.56,
    y1: 67.62,
    x2: 99.56,
    y2: 138.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 10.56,
    y1: 88.38,
    x2: 77.56,
    y2: 159.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 17.89,
    y1: 81.46,
    x2: 84.89,
    y2: 152.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 54.44,
    y1: 46.97,
    x2: 121.44,
    y2: 117.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 61.77,
    y1: 40.05,
    x2: 128.78,
    y2: 111.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 39.78,
    y1: 60.81,
    x2: 106.78,
    y2: 131.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 47.11,
    y1: 53.89,
    x2: 114.11,
    y2: 124.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 25.94,
    y1: 73.87,
    x2: 92.94,
    y2: 144.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 33.27,
    y1: 66.95,
    x2: 100.27,
    y2: 137.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 11.27,
    y1: 87.71,
    x2: 78.27,
    y2: 158.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 18.6,
    y1: 80.79,
    x2: 85.61,
    y2: 151.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 55.16,
    y1: 46.3,
    x2: 122.16,
    y2: 117.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 62.49,
    y1: 39.38,
    x2: 129.49,
    y2: 110.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 40.49,
    y1: 60.14,
    x2: 107.49,
    y2: 131.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 47.82,
    y1: 53.22,
    x2: 114.82,
    y2: 124.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 19.84,
    y1: 79.63,
    x2: 86.84,
    y2: 150.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 27.17,
    y1: 72.7,
    x2: 94.17,
    y2: 143.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 5.18,
    y1: 93.47,
    x2: 72.17,
    y2: 164.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 12.51,
    y1: 86.55,
    x2: 79.51,
    y2: 157.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 49.06,
    y1: 52.06,
    x2: 116.06,
    y2: 123.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 56.4,
    y1: 45.14,
    x2: 123.39,
    y2: 116.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 34.39,
    y1: 65.89,
    x2: 101.39,
    y2: 136.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 41.73,
    y1: 58.98,
    x2: 108.73,
    y2: 129.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 20.55,
    y1: 78.95,
    x2: 87.55,
    y2: 149.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 27.88,
    y1: 72.03,
    x2: 94.88,
    y2: 143.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 5.89,
    y1: 92.79,
    x2: 72.89,
    y2: 163.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 13.22,
    y1: 85.87,
    x2: 80.22,
    y2: 156.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 49.78,
    y1: 51.39,
    x2: 116.77,
    y2: 122.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 57.1,
    y1: 44.46,
    x2: 124.1,
    y2: 115.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 35.1,
    y1: 65.22,
    x2: 102.11,
    y2: 136.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 42.44,
    y1: 58.3,
    x2: 109.44,
    y2: 129.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 14.45,
    y1: 84.71,
    x2: 81.45,
    y2: 155.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 21.78,
    y1: 77.78,
    x2: 88.79,
    y2: 148.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -0.21,
    y1: 98.55,
    x2: 66.79,
    y2: 169.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 7.12,
    y1: 91.63,
    x2: 74.12,
    y2: 162.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 43.67,
    y1: 57.14,
    x2: 110.67,
    y2: 128.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 51.01,
    y1: 50.22,
    x2: 118.01,
    y2: 121.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 29.01,
    y1: 70.97,
    x2: 96.01,
    y2: 141.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 36.34,
    y1: 64.06,
    x2: 103.34,
    y2: 135.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 42.76,
    y1: 57.99,
    x2: 109.76,
    y2: 128.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 50.1,
    y1: 51.07,
    x2: 117.1,
    y2: 122.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 28.1,
    y1: 71.83,
    x2: 95.09,
    y2: 142.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 35.43,
    y1: 64.91,
    x2: 102.43,
    y2: 135.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 71.98,
    y1: 30.42,
    x2: 138.99,
    y2: 101.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 79.32,
    y1: 23.5,
    x2: 146.32,
    y2: 94.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 57.32,
    y1: 44.26,
    x2: 124.32,
    y2: 115.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 64.65,
    y1: 37.34,
    x2: 131.65,
    y2: 108.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 519.41,
    y1: 69.02,
    x2: 562.64,
    y2: 85.29,
    gradientTransform: "matrix(-1, 0, 0, 1, 614.16, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d5d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 37.86,
    y1: 96.61,
    x2: 111.42,
    y2: 96.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec1c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f181b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 37.87,
    y1: 94.45,
    x2: 67.62,
    y2: 94.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.8 85.97 52.51 74.5 38.05 111.22 59.3 113.85 67.8 85.97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 51.07,
    y1: 76.87,
    x2: 32.07,
    y2: 119.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 56.57,
    y1: 79.33,
    x2: 37.57,
    y2: 121.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 40.07,
    y1: 71.96,
    x2: 21.07,
    y2: 114.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 45.57,
    y1: 74.41,
    x2: 26.57,
    y2: 116.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 72.98,
    y1: 86.67,
    x2: 53.98,
    y2: 129.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 78.48,
    y1: 89.12,
    x2: 59.48,
    y2: 131.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 61.98,
    y1: 81.75,
    x2: 42.98,
    y2: 124.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 67.48,
    y1: 84.21,
    x2: 48.48,
    y2: 126.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 46.54,
    y1: 74.85,
    x2: 27.54,
    y2: 117.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 52.03,
    y1: 77.3,
    x2: 33.04,
    y2: 119.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 35.54,
    y1: 69.93,
    x2: 16.54,
    y2: 112.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 41.04,
    y1: 72.39,
    x2: 22.04,
    y2: 114.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 68.44,
    y1: 84.64,
    x2: 49.44,
    y2: 127.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 73.94,
    y1: 87.1,
    x2: 54.94,
    y2: 129.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 57.45,
    y1: 79.72,
    x2: 38.45,
    y2: 122.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 62.95,
    y1: 82.18,
    x2: 43.95,
    y2: 124.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 50.5,
    y1: 76.62,
    x2: 31.5,
    y2: 119.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 56,
    y1: 79.07,
    x2: 37,
    y2: 121.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 39.5,
    y1: 71.7,
    x2: 20.5,
    y2: 114.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 45,
    y1: 74.16,
    x2: 26,
    y2: 116.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 72.4,
    y1: 86.41,
    x2: 53.41,
    y2: 128.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 77.9,
    y1: 88.87,
    x2: 58.9,
    y2: 131.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 61.41,
    y1: 81.49,
    x2: 42.41,
    y2: 124,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 66.91,
    y1: 83.95,
    x2: 47.91,
    y2: 126.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 55.03,
    y1: 78.64,
    x2: 36.03,
    y2: 121.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 60.53,
    y1: 81.1,
    x2: 41.53,
    y2: 123.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 44.03,
    y1: 73.73,
    x2: 25.04,
    y2: 116.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 49.53,
    y1: 76.19,
    x2: 30.53,
    y2: 118.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 76.94,
    y1: 88.44,
    x2: 57.94,
    y2: 130.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 82.44,
    y1: 90.9,
    x2: 63.44,
    y2: 133.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 65.94,
    y1: 83.52,
    x2: 46.94,
    y2: 126.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 71.44,
    y1: 85.98,
    x2: 52.44,
    y2: 128.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 54.46,
    y1: 78.39,
    x2: 35.46,
    y2: 120.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 59.96,
    y1: 80.85,
    x2: 40.96,
    y2: 123.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 43.46,
    y1: 73.47,
    x2: 24.46,
    y2: 115.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 48.96,
    y1: 75.93,
    x2: 29.96,
    y2: 118.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 76.37,
    y1: 88.18,
    x2: 57.36,
    y2: 130.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 81.86,
    y1: 90.64,
    x2: 62.86,
    y2: 133.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 65.37,
    y1: 83.27,
    x2: 46.37,
    y2: 125.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 70.87,
    y1: 85.72,
    x2: 51.87,
    y2: 128.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 58.99,
    y1: 80.41,
    x2: 39.99,
    y2: 122.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 64.49,
    y1: 82.87,
    x2: 45.49,
    y2: 125.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 48,
    y1: 75.5,
    x2: 29,
    y2: 118,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 53.49,
    y1: 77.96,
    x2: 34.49,
    y2: 120.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 80.9,
    y1: 90.21,
    x2: 61.9,
    y2: 132.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 86.4,
    y1: 92.67,
    x2: 67.4,
    y2: 135.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 69.9,
    y1: 85.29,
    x2: 50.9,
    y2: 127.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 75.4,
    y1: 87.75,
    x2: 56.4,
    y2: 130.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 58.42,
    y1: 80.16,
    x2: 39.42,
    y2: 122.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 63.92,
    y1: 82.61,
    x2: 44.92,
    y2: 125.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 47.42,
    y1: 75.24,
    x2: 28.42,
    y2: 117.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 52.92,
    y1: 77.7,
    x2: 33.92,
    y2: 120.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 80.33,
    y1: 89.95,
    x2: 61.33,
    y2: 132.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 85.82,
    y1: 92.41,
    x2: 66.82,
    y2: 134.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 69.33,
    y1: 85.04,
    x2: 50.33,
    y2: 127.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 74.83,
    y1: 87.49,
    x2: 55.83,
    y2: 129.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 62.95,
    y1: 82.19,
    x2: 43.95,
    y2: 124.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 68.45,
    y1: 84.64,
    x2: 49.45,
    y2: 127.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 51.96,
    y1: 77.27,
    x2: 32.96,
    y2: 119.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 57.45,
    y1: 79.73,
    x2: 38.45,
    y2: 122.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 84.86,
    y1: 91.98,
    x2: 65.86,
    y2: 134.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 90.36,
    y1: 94.44,
    x2: 71.36,
    y2: 136.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 73.86,
    y1: 87.06,
    x2: 54.86,
    y2: 129.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 79.36,
    y1: 89.52,
    x2: 60.36,
    y2: 132.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 62.38,
    y1: 81.93,
    x2: 43.38,
    y2: 124.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 67.88,
    y1: 84.39,
    x2: 48.88,
    y2: 126.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 51.38,
    y1: 77.01,
    x2: 32.38,
    y2: 119.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 56.88,
    y1: 79.47,
    x2: 37.88,
    y2: 121.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 84.29,
    y1: 91.72,
    x2: 65.29,
    y2: 134.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 89.79,
    y1: 94.18,
    x2: 70.78,
    y2: 136.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 73.29,
    y1: 86.81,
    x2: 54.29,
    y2: 129.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 78.79,
    y1: 89.26,
    x2: 59.79,
    y2: 131.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 47.61,
    y1: 75.33,
    x2: 28.61,
    y2: 117.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 53.11,
    y1: 77.78,
    x2: 34.11,
    y2: 120.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 36.62,
    y1: 70.41,
    x2: 17.62,
    y2: 112.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 42.11,
    y1: 72.87,
    x2: 23.11,
    y2: 115.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 69.52,
    y1: 85.12,
    x2: 50.52,
    y2: 127.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 75.02,
    y1: 87.58,
    x2: 56.02,
    y2: 130.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 58.52,
    y1: 80.2,
    x2: 39.52,
    y2: 122.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 64.02,
    y1: 82.66,
    x2: 45.02,
    y2: 125.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 126.19,
    y1: 114.2,
    x2: 140.43,
    y2: 114.2,
    gradientTransform: "translate(8.07 -81) rotate(13.8)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 92.88,
    y1: 106.4,
    x2: 115.31,
    y2: 106.4,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 93.93,
    y1: 98.39,
    x2: 109.87,
    y2: 102.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 100.13,
    y1: 95.48,
    x2: 101.63,
    y2: 97.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 445.03,
    y1: 216.06,
    x2: 460.97,
    y2: 219.98,
    gradientTransform: "matrix(-0.62, -0.6, -0.7, 0.72, 524.7, 212.36)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 451.24,
    y1: 213.15,
    x2: 452.74,
    y2: 215.09,
    gradientTransform: "matrix(-0.62, -0.6, -0.7, 0.72, 524.7, 212.36)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 119.06,
    y1: 47.99,
    x2: 86.59,
    y2: 103.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 101.55,
    y1: 109.43,
    x2: 117.88,
    y2: 109.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 542.93,
    y1: -100.28,
    x2: 521.6,
    y2: -32.94,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.75,160.25l28.37-5.36s5.62-.53,5.62-7.23V121.94l-99.6-11.52s25.12,37.51,33,44.21c.88.74,4.92,1.63,9.88,2.48C85.62,158.76,98.75,160.25,98.75,160.25Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 483.7,
    y1: -96.94,
    x2: 550.69,
    y2: -25.95,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 491.03,
    y1: -103.86,
    x2: 558.03,
    y2: -32.86,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 469.03,
    y1: -83.1,
    x2: 536.04,
    y2: -12.1,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 476.36,
    y1: -90.02,
    x2: 543.37,
    y2: -19.02,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 512.91,
    y1: -124.51,
    x2: 579.91,
    y2: -53.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 520.24,
    y1: -131.44,
    x2: 587.25,
    y2: -60.43,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 498.25,
    y1: -110.68,
    x2: 565.25,
    y2: -39.68,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 505.58,
    y1: -117.6,
    x2: 572.58,
    y2: -46.59,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 482.98,
    y1: -96.27,
    x2: 549.98,
    y2: -25.27,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 490.32,
    y1: -103.19,
    x2: 557.31,
    y2: -32.2,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 468.32,
    y1: -82.43,
    x2: 535.31,
    y2: -11.44,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 475.65,
    y1: -89.35,
    x2: 542.65,
    y2: -18.35,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 512.2,
    y1: -123.84,
    x2: 579.2,
    y2: -52.84,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 519.54,
    y1: -130.76,
    x2: 586.54,
    y2: -59.76,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 497.54,
    y1: -110,
    x2: 564.54,
    y2: -39.01,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 504.87,
    y1: -116.92,
    x2: 571.87,
    y2: -45.92,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 477.6,
    y1: -91.19,
    x2: 544.6,
    y2: -20.18,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 484.93,
    y1: -98.1,
    x2: 551.93,
    y2: -27.11,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 462.93,
    y1: -77.35,
    x2: 529.93,
    y2: -6.35,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 470.26,
    y1: -84.27,
    x2: 537.27,
    y2: -13.26,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 506.82,
    y1: -118.76,
    x2: 573.82,
    y2: -47.76,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 514.15,
    y1: -125.68,
    x2: 581.15,
    y2: -54.68,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 492.15,
    y1: -104.92,
    x2: 559.15,
    y2: -33.92,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 499.49,
    y1: -111.84,
    x2: 566.48,
    y2: -40.84,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 478.31,
    y1: -91.86,
    x2: 545.31,
    y2: -20.86,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 485.64,
    y1: -98.78,
    x2: 552.64,
    y2: -27.78,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 463.64,
    y1: -78.02,
    x2: 530.64,
    y2: -7.02,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 470.98,
    y1: -84.93,
    x2: 537.97,
    y2: -13.95,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 507.53,
    y1: -119.43,
    x2: 574.53,
    y2: -48.43,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 514.87,
    y1: -126.35,
    x2: 581.86,
    y2: -55.35,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 492.87,
    y1: -105.59,
    x2: 559.86,
    y2: -34.59,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 500.2,
    y1: -112.51,
    x2: 567.2,
    y2: -41.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 472.21,
    y1: -86.1,
    x2: 539.21,
    y2: -15.1,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 479.54,
    y1: -93.03,
    x2: 546.55,
    y2: -22.02,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 457.54,
    y1: -72.27,
    x2: 524.55,
    y2: -1.26,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 464.88,
    y1: -79.18,
    x2: 531.88,
    y2: -8.18,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 501.43,
    y1: -113.68,
    x2: 568.43,
    y2: -42.68,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 508.76,
    y1: -120.6,
    x2: 575.76,
    y2: -49.6,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 486.77,
    y1: -99.83,
    x2: 553.76,
    y2: -28.84,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 494.1,
    y1: -106.76,
    x2: 561.1,
    y2: -35.76,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 472.92,
    y1: -86.78,
    x2: 539.92,
    y2: -15.77,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 480.26,
    y1: -93.69,
    x2: 547.26,
    y2: -22.7,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 458.26,
    y1: -72.93,
    x2: 525.26,
    y2: -1.94,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 465.59,
    y1: -79.85,
    x2: 532.59,
    y2: -8.86,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 502.15,
    y1: -114.35,
    x2: 569.14,
    y2: -43.35,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 509.48,
    y1: -121.27,
    x2: 576.48,
    y2: -50.27,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 487.48,
    y1: -100.5,
    x2: 554.48,
    y2: -29.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 494.81,
    y1: -107.43,
    x2: 561.81,
    y2: -36.43,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 466.83,
    y1: -81.02,
    x2: 533.82,
    y2: -10.02,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 474.16,
    y1: -87.94,
    x2: 541.16,
    y2: -16.94,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 452.16,
    y1: -67.18,
    x2: 519.16,
    y2: 3.82,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 459.5,
    y1: -74.1,
    x2: 526.49,
    y2: -3.1,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 496.05,
    y1: -108.59,
    x2: 563.04,
    y2: -37.59,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 503.39,
    y1: -115.51,
    x2: 570.38,
    y2: -44.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 481.38,
    y1: -94.75,
    x2: 548.38,
    y2: -23.76,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 488.72,
    y1: -101.67,
    x2: 555.71,
    y2: -30.68,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 467.54,
    y1: -81.69,
    x2: 534.54,
    y2: -10.69,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 474.87,
    y1: -88.61,
    x2: 541.87,
    y2: -17.61,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 452.88,
    y1: -67.85,
    x2: 519.87,
    y2: 3.14,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 460.2,
    y1: -74.78,
    x2: 527.21,
    y2: -3.77,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 496.76,
    y1: -109.26,
    x2: 563.76,
    y2: -38.27,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 504.09,
    y1: -116.19,
    x2: 571.09,
    y2: -45.19,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 482.09,
    y1: -95.43,
    x2: 549.09,
    y2: -24.43,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 489.42,
    y1: -102.35,
    x2: 556.42,
    y2: -31.35,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 461.44,
    y1: -75.93,
    x2: 528.44,
    y2: -4.94,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 468.76,
    y1: -82.87,
    x2: 535.77,
    y2: -11.86,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 446.78,
    y1: -62.1,
    x2: 513.77,
    y2: 8.9,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 454.11,
    y1: -69.02,
    x2: 521.11,
    y2: 1.98,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 490.66,
    y1: -103.51,
    x2: 557.66,
    y2: -32.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 497.99,
    y1: -110.43,
    x2: 564.99,
    y2: -39.43,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 475.99,
    y1: -89.67,
    x2: 542.99,
    y2: -18.67,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 483.33,
    y1: -96.59,
    x2: 550.33,
    y2: -25.59,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 489.75,
    y1: -102.65,
    x2: 556.75,
    y2: -31.66,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 497.08,
    y1: -109.58,
    x2: 564.09,
    y2: -38.57,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 475.09,
    y1: -88.82,
    x2: 542.08,
    y2: -17.82,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 482.42,
    y1: -95.74,
    x2: 549.42,
    y2: -24.74,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 518.97,
    y1: -130.23,
    x2: 585.97,
    y2: -59.23,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 526.3,
    y1: -137.15,
    x2: 593.31,
    y2: -66.14,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 504.31,
    y1: -116.39,
    x2: 571.31,
    y2: -45.39,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 511.64,
    y1: -123.31,
    x2: 578.63,
    y2: -52.31,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 72.43,
    y1: -91.63,
    x2: 115.65,
    y2: -75.36,
    gradientTransform: "matrix(1, 0, 0, -1, -1.77, 72.08)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 484.85,
    y1: -64.04,
    x2: 558.41,
    y2: -64.04,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 484.86,
    y1: -66.2,
    x2: 514.61,
    y2: -66.2,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.61 146.75 112.9 158.23 127.36 121.5 106.11 118.88 97.61 146.75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 498.06,
    y1: -83.77,
    x2: 479.06,
    y2: -41.28,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 503.55,
    y1: -81.32,
    x2: 484.56,
    y2: -38.82,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 487.06,
    y1: -88.69,
    x2: 468.06,
    y2: -46.19,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 492.56,
    y1: -86.23,
    x2: 473.56,
    y2: -43.74,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 519.96,
    y1: -73.98,
    x2: 500.96,
    y2: -31.48,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 525.46,
    y1: -71.52,
    x2: 506.46,
    y2: -29.02,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 508.97,
    y1: -78.9,
    x2: 489.97,
    y2: -36.4,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 514.47,
    y1: -76.44,
    x2: 495.47,
    y2: -33.94,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 493.52,
    y1: -85.8,
    x2: 474.52,
    y2: -43.3,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 499.02,
    y1: -83.34,
    x2: 480.02,
    y2: -40.84,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 482.53,
    y1: -90.72,
    x2: 463.53,
    y2: -48.22,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 488.03,
    y1: -88.26,
    x2: 469.02,
    y2: -45.76,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 515.43,
    y1: -76.01,
    x2: 496.43,
    y2: -33.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 520.93,
    y1: -73.55,
    x2: 501.93,
    y2: -31.05,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 504.43,
    y1: -80.92,
    x2: 485.43,
    y2: -38.42,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 509.93,
    y1: -78.47,
    x2: 490.94,
    y2: -35.97,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 497.48,
    y1: -84.03,
    x2: 478.48,
    y2: -41.53,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 502.98,
    y1: -81.57,
    x2: 483.98,
    y2: -39.07,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 486.49,
    y1: -88.95,
    x2: 467.49,
    y2: -46.45,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 491.99,
    y1: -86.49,
    x2: 472.98,
    y2: -43.99,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 519.39,
    y1: -74.24,
    x2: 500.39,
    y2: -31.74,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 524.89,
    y1: -71.78,
    x2: 505.89,
    y2: -29.28,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 508.4,
    y1: -79.15,
    x2: 489.39,
    y2: -36.65,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 513.89,
    y1: -76.69,
    x2: 494.9,
    y2: -34.2,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 502.02,
    y1: -82,
    x2: 483.02,
    y2: -39.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 507.51,
    y1: -79.55,
    x2: 488.52,
    y2: -37.05,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 491.02,
    y1: -86.92,
    x2: 472.02,
    y2: -44.42,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 496.52,
    y1: -84.46,
    x2: 477.52,
    y2: -41.96,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 523.92,
    y1: -72.21,
    x2: 504.92,
    y2: -29.71,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 529.42,
    y1: -69.75,
    x2: 510.42,
    y2: -27.25,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 512.93,
    y1: -77.13,
    x2: 493.93,
    y2: -34.63,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: 518.43,
    y1: -74.67,
    x2: 499.43,
    y2: -32.17,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: 501.44,
    y1: -82.26,
    x2: 482.44,
    y2: -39.76,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 506.94,
    y1: -79.8,
    x2: 487.94,
    y2: -37.3,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 490.45,
    y1: -87.18,
    x2: 471.45,
    y2: -44.68,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: 495.95,
    y1: -84.72,
    x2: 476.95,
    y2: -42.22,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 523.35,
    y1: -72.47,
    x2: 504.35,
    y2: -29.97,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: 528.85,
    y1: -70.01,
    x2: 509.85,
    y2: -27.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 512.36,
    y1: -77.38,
    x2: 493.36,
    y2: -34.88,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 517.85,
    y1: -74.92,
    x2: 498.85,
    y2: -32.43,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 505.98,
    y1: -80.23,
    x2: 486.98,
    y2: -37.74,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 511.47,
    y1: -77.77,
    x2: 492.48,
    y2: -35.28,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 494.98,
    y1: -85.15,
    x2: 475.98,
    y2: -42.65,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 500.48,
    y1: -82.69,
    x2: 481.48,
    y2: -40.19,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 527.89,
    y1: -70.44,
    x2: 508.88,
    y2: -27.94,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 533.38,
    y1: -67.98,
    x2: 514.38,
    y2: -25.48,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: 516.89,
    y1: -75.35,
    x2: 497.89,
    y2: -32.86,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: 522.39,
    y1: -72.9,
    x2: 503.39,
    y2: -30.4,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: 505.4,
    y1: -80.49,
    x2: 486.4,
    y2: -37.99,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: 510.9,
    y1: -78.04,
    x2: 491.9,
    y2: -35.53,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: 494.41,
    y1: -85.41,
    x2: 475.41,
    y2: -42.91,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: 499.91,
    y1: -82.95,
    x2: 480.91,
    y2: -40.45,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: 527.31,
    y1: -70.69,
    x2: 508.31,
    y2: -28.2,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: 532.81,
    y1: -68.24,
    x2: 513.81,
    y2: -25.74,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: 516.32,
    y1: -75.61,
    x2: 497.32,
    y2: -33.11,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: 521.81,
    y1: -73.15,
    x2: 502.82,
    y2: -30.66,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: 509.94,
    y1: -78.46,
    x2: 490.94,
    y2: -35.96,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: 515.44,
    y1: -76,
    x2: 496.44,
    y2: -33.51,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: 498.94,
    y1: -83.38,
    x2: 479.94,
    y2: -40.88,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: 504.44,
    y1: -80.92,
    x2: 485.44,
    y2: -38.42,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: 531.85,
    y1: -68.67,
    x2: 512.85,
    y2: -26.17,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: 537.34,
    y1: -66.21,
    x2: 518.34,
    y2: -23.71,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: 520.85,
    y1: -73.58,
    x2: 501.85,
    y2: -31.09,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: 526.35,
    y1: -71.13,
    x2: 507.35,
    y2: -28.63,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: 509.37,
    y1: -78.72,
    x2: 490.36,
    y2: -36.22,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: 514.86,
    y1: -76.26,
    x2: 495.86,
    y2: -33.76,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: 498.37,
    y1: -83.64,
    x2: 479.37,
    y2: -41.14,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: 503.87,
    y1: -81.18,
    x2: 484.87,
    y2: -38.68,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: 531.27,
    y1: -68.92,
    x2: 512.27,
    y2: -26.43,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: 536.77,
    y1: -66.47,
    x2: 517.77,
    y2: -23.97,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: 520.28,
    y1: -73.84,
    x2: 501.28,
    y2: -31.34,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: 525.77,
    y1: -71.38,
    x2: 506.78,
    y2: -28.88,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: 494.6,
    y1: -85.32,
    x2: 475.6,
    y2: -42.82,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: 500.1,
    y1: -82.86,
    x2: 481.09,
    y2: -40.36,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: 483.6,
    y1: -90.24,
    x2: 464.6,
    y2: -47.73,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: 489.1,
    y1: -87.78,
    x2: 470.1,
    y2: -45.28,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: 516.51,
    y1: -75.53,
    x2: 497.51,
    y2: -33.03,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: 522,
    y1: -73.07,
    x2: 503.01,
    y2: -30.57,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: 505.51,
    y1: -80.44,
    x2: 486.51,
    y2: -37.94,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: 511.01,
    y1: -77.99,
    x2: 492.01,
    y2: -35.49,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: 521.94,
    y1: -148.46,
    x2: 536.18,
    y2: -148.46,
    gradientTransform: "translate(604.33 153.08) rotate(-166.2)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: 539.87,
    y1: -54.25,
    x2: 562.29,
    y2: -54.25,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: 540.92,
    y1: -62.26,
    x2: 556.85,
    y2: -58.34,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: 547.12,
    y1: -65.17,
    x2: 548.62,
    y2: -63.23,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: 203.26,
    y1: -210.55,
    x2: 219.2,
    y2: -206.63,
    gradientTransform: "matrix(0.62, 0.6, 0.7, -0.72, 87.69, -140.28)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: 209.47,
    y1: -213.47,
    x2: 210.97,
    y2: -211.53,
    gradientTransform: "matrix(0.62, 0.6, 0.7, -0.72, 87.69, -140.28)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: 566.05,
    y1: -112.66,
    x2: 533.57,
    y2: -57.04,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: 548.54,
    y1: -51.22,
    x2: 564.87,
    y2: -51.22,
    gradientTransform: "translate(612.39 72.08) rotate(180)",
    xlinkHref: "#linear-gradient-82"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1901.82,
    y: -743.25,
    width: 2406.31,
    height: 1210.9
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(6.64 8.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACdElEQVR4Xu3WQWrDQBQFwT/C97/yZBMbCRJCbLdXVRtpYJbNk9bee04uB3jSOh+O07vAeJdLS/fIBMa7PZo6LxkkjrFidPaMJeMDREZOZORERm2LjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImM2hIZOZGRExm5Y2bWX5fgSWvGkvEBt+/nfc32bxfhHy5fx9tciY1X/Pjr9QV0hQ6xSIqRZgAAAABJRU5ErkJggg=="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.39,28.94l8.06,8a15.11,15.11,0,0,0,3.39,2.7,7.13,7.13,0,0,0,2.81.81v.6H26.24v-.6a2.24,2.24,0,0,0,1.35-.31.87.87,0,0,0,.41-.7,1.52,1.52,0,0,0-.15-.69,5.91,5.91,0,0,0-1-1.15l-7.55-7.47V37.2a7.17,7.17,0,0,0,.21,2.19,1.52,1.52,0,0,0,.68.7,2.93,2.93,0,0,0,1.47.38h.74v.6H13.07v-.6h.77a2.35,2.35,0,0,0,2-.78,4.93,4.93,0,0,0,.39-2.49V23.08A7.5,7.5,0,0,0,16,20.86a1.51,1.51,0,0,0-.66-.67,3.07,3.07,0,0,0-1.49-.39h-.77v-.6h9.32v.6h-.74a3.23,3.23,0,0,0-1.47.37,1.39,1.39,0,0,0-.69.78,7.23,7.23,0,0,0-.2,2.13v6.69l2.21-2.05a47.62,47.62,0,0,0,5.79-5.86,2.08,2.08,0,0,0,.44-1.12.83.83,0,0,0-.34-.66,1.88,1.88,0,0,0-1.15-.28h-.5v-.6h8v.6a4.59,4.59,0,0,0-1.29.2,6.1,6.1,0,0,0-1.42.68A13.65,13.65,0,0,0,29,22.32c-.23.21-1.33,1.31-3.27,3.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143,203.78l-8.07-8a14.33,14.33,0,0,0-3.38-2.7,7.32,7.32,0,0,0-2.81-.82v-.6h10.4v.6a2.22,2.22,0,0,0-1.34.32.88.88,0,0,0-.42.7,1.41,1.41,0,0,0,.16.69,5.56,5.56,0,0,0,1,1.15l7.54,7.46v-7a7.3,7.3,0,0,0-.21-2.2,1.41,1.41,0,0,0-.68-.69,2.93,2.93,0,0,0-1.46-.39H143v-.6h9.32v.6h-.78a2.37,2.37,0,0,0-2,.79,5.06,5.06,0,0,0-.38,2.49v14.12a7.38,7.38,0,0,0,.21,2.21,1.43,1.43,0,0,0,.66.68,3,3,0,0,0,1.48.39h.78v.59H143v-.59h.74a3.09,3.09,0,0,0,1.46-.38,1.39,1.39,0,0,0,.7-.77,7.34,7.34,0,0,0,.19-2.13V203l-2.21,2a48.69,48.69,0,0,0-5.79,5.85,2.11,2.11,0,0,0-.43,1.13.82.82,0,0,0,.34.65,1.76,1.76,0,0,0,1.14.29h.5v.59h-8v-.59a5.13,5.13,0,0,0,1.29-.2,7.05,7.05,0,0,0,1.42-.68,13.8,13.8,0,0,0,2.06-1.64q.36-.33,3.28-3.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.4,43.28S17,46.42,17,51.33a2.85,2.85,0,0,0,5.32,1.42,2.05,2.05,0,0,0-.28-2.4s1.58.63.93,3.91c-.08.49-.2,1.05-.37,1.71h1.64c-.17-.66-.29-1.22-.38-1.71-.64-3.28.94-3.91.94-3.91a2.07,2.07,0,0,0-.29,2.4,2.86,2.86,0,0,0,5.33-1.42C29.82,46.42,23.4,43.28,23.4,43.28Z"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 11,
    transform: "translate(16.64 43.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAAACXBIWXMAAAsSAAALEgHS3X78AAABIElEQVQoU22Ry07DQAxFTyaTdJL0RVXWJGqAPfD/XwDiByq1OxCLigUkTeZhFqVVKLXkha99bNmORIRLVpeVAKy3m+g8F51DdVnJeDIlLwo+3t+4BKphcL+6ldl8TjoaAbBYXp8aXYTuVrWYzJAaQ57njDKDMYbZ/OofqI5CFEUU4wkAAnjnUXHMZDplsVz+ARWA1hpjDPu2RSmFtT0SAs5anPckSYrJMrTW1GUlCsA5RwgBrTXeeQDapkFECN4TQiAvCpL0sKuuy0qSNAUOB/LO4Zzw/PoSATw9PEq37xAJHE2tt5vIWYtIoG0bum7P5253Kui7Hucs1lr6rjtMAhARbN+j4hjO/tZ8f5EkKRKEEH6nicjJVzelDOOhPsz9AI1zpaSQdMAOAAAAAElFTkSuQmCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142,189.45s6.41-3.14,6.41-8.06A2.85,2.85,0,0,0,143.1,180a2.07,2.07,0,0,0,.29,2.4s-1.58-.62-.94-3.91c.08-.49.21-1.05.38-1.7h-1.64c.17.65.29,1.21.37,1.7.65,3.29-.93,3.91-.93,3.91a2.06,2.06,0,0,0,.28-2.4,2.85,2.85,0,0,0-5.32,1.42C135.59,186.31,142,189.45,142,189.45Z"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 10,
    transform: "translate(135.64 179.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAACXBIWXMAAAsSAAALEgHS3X78AAABFklEQVQoU1WRTVKDQBCFv+6ZgQSI8QaCxgtYev8jaLmwTFUsPYCJiwD5AWZckJDQu+7X7/XPkxACi7wInGL18y1cxTV2xvVcVDVEcTxqWuRFiCcTnHPEcTwQLYC1Fusc3nuSNBvAbDbDe491jq5tEREWeREUYJqkCMLsZk6Sprw8PffTjWGapMRRjBoziMnDXR4AkjQjzTJUFREBEXzXAeB9x363Y1fXLL9WoteHiwiifSr0axtrUDVUZUl3EtEzoa5K/jZrfOdxUYR1DlGlbdpeRHX4rMLlzU3TsFn/Um23IFBXFcfDnqrcDqsCSAgXGx6L+2CspWtbbua3HI8HrHW8vr+NvBuR4GJmmmU0TcPH8nNEAPgH0oVxTI90A1cAAAAASUVORK5CYII="
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.65,72.47,38.28,77.83s-5.61.54-5.61,7.23v25.72l99.6,11.52s-25.12-37.5-33-44.2c-.88-.75-4.92-1.64-9.88-2.48C79.78,74,66.65,72.47,66.65,72.47Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.5,80.14S51.69,84,52.92,87.5a2.17,2.17,0,0,0,4.17-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.56c.06.37.11.8.15,1.31l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.56,1.56,0,0,0,.39,1.79,2.19,2.19,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C60.87,80.77,55.5,80.14,55.5,80.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66,76.56s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28.05,1.65,2.57c.06.36.11.8.15,1.3l1.17-.4c-.28-.43-.51-.8-.69-1.13-1.28-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C71.36,77.2,66,76.56,66,76.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.53,87.29S30.72,91.14,32,94.65a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28,0,1.64,2.57a12,12,0,0,1,.16,1.31l1.17-.41c-.29-.43-.51-.8-.69-1.13-1.29-2.18-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C39.9,87.93,34.53,87.29,34.53,87.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45,83.71s-3.8,3.85-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29.06,1.65,2.57A12.35,12.35,0,0,1,47.6,93l1.17-.41c-.29-.42-.51-.8-.69-1.12-1.29-2.19-.31-3-.31-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.45-2.34C50.39,84.35,45,83.71,45,83.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.29,65.88s-3.81,3.85-2.58,7.36a2.15,2.15,0,0,0,2.75,1.33,2.2,2.2,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.28,0,1.65,2.57c.06.36.11.8.15,1.31l1.17-.41c-.28-.42-.51-.8-.69-1.13-1.28-2.18-.31-3-.31-3a1.58,1.58,0,0,0,.4,1.78A2.16,2.16,0,0,0,103.89,70C102.66,66.52,97.29,65.88,97.29,65.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M107.78,62.3s-3.81,3.85-2.58,7.37a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.8-1.66s1.28.06,1.64,2.57a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.28-.42-.51-.79-.69-1.12-1.29-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C113.15,62.94,107.78,62.3,107.78,62.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M76.31,73s-3.8,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.81-1.65s1.29,0,1.65,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.4,2.17,2.17,0,0,0,1.33-2.75C81.69,73.67,76.31,73,76.31,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M86.8,69.46S83,73.3,84.23,76.82a2.16,2.16,0,0,0,4.16-.31,1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.57a10.18,10.18,0,0,1,.15,1.3l1.18-.4a11.54,11.54,0,0,1-.69-1.13c-1.29-2.19-.31-3-.31-3A1.57,1.57,0,0,0,90,76a2.2,2.2,0,0,0,2.13.41,2.17,2.17,0,0,0,1.32-2.76C92.17,70.1,86.8,69.46,86.8,69.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M47.75,73.35s-3.81,3.84-2.58,7.36A2.16,2.16,0,0,0,47.92,82a2.2,2.2,0,0,0,1.42-1.64,1.58,1.58,0,0,0-.81-1.65s1.28,0,1.64,2.57a12.13,12.13,0,0,1,.16,1.3l1.17-.4c-.28-.43-.51-.8-.69-1.13-1.28-2.19-.31-3-.31-3a1.58,1.58,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C53.12,74,47.75,73.35,47.75,73.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.24,69.77s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31A1.57,1.57,0,0,0,59,75.17s1.29,0,1.65,2.57a12.13,12.13,0,0,1,.16,1.3l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,2.12.41,2.18,2.18,0,0,0,1.33-2.76C63.61,70.41,58.24,69.77,58.24,69.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M26.77,80.5S23,84.35,24.2,87.86a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.57a12,12,0,0,1,.16,1.31l1.17-.41a12.38,12.38,0,0,1-.69-1.13c-1.29-2.18-.31-3-.31-3A1.57,1.57,0,0,0,29.92,87a2.16,2.16,0,0,0,3.45-2.34C32.15,81.14,26.77,80.5,26.77,80.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M37.26,76.92s-3.81,3.85-2.57,7.37A2.16,2.16,0,0,0,38.85,84,1.58,1.58,0,0,0,38,82.33s1.29,0,1.65,2.56a10.36,10.36,0,0,1,.15,1.31L41,85.79c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.3-3-.3-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.45-2.34C42.63,77.56,37.26,76.92,37.26,76.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M89.53,59.09s-3.8,3.85-2.57,7.37a2.16,2.16,0,0,0,4.16-.32,1.59,1.59,0,0,0-.8-1.65s1.28.06,1.64,2.57a12.35,12.35,0,0,1,.16,1.31L93.29,68c-.29-.42-.51-.8-.69-1.12-1.29-2.19-.31-3-.31-3a1.54,1.54,0,0,0,.4,1.78,2.15,2.15,0,0,0,3.44-2.34C94.91,59.73,89.53,59.09,89.53,59.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M100,55.52s-3.8,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.81-1.65s1.29,0,1.65,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.4c-.29-.43-.51-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C105.4,56.15,100,55.52,100,55.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.56,66.25S64.75,70.09,66,73.61a2.15,2.15,0,0,0,2.74,1.33,2.18,2.18,0,0,0,1.42-1.64,1.57,1.57,0,0,0-.81-1.65s1.29,0,1.65,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C73.93,66.88,68.56,66.25,68.56,66.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M79.05,62.67S75.24,66.51,76.47,70a2.17,2.17,0,0,0,4.17-.31,1.6,1.6,0,0,0-.81-1.65s1.28.05,1.65,2.57c.06.36.11.8.15,1.3l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C84.42,63.31,79.05,62.67,79.05,62.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M53.51,90.25s-3.81,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.56a10.36,10.36,0,0,1,.15,1.31l1.18-.41a12.69,12.69,0,0,1-.7-1.12c-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C58.88,90.88,53.51,90.25,53.51,90.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64,86.67S60.19,90.51,61.42,94a2.17,2.17,0,0,0,4.17-.31,1.6,1.6,0,0,0-.81-1.65s1.29.05,1.65,2.57c.06.36.11.8.15,1.3l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.31-3-.31-3a1.59,1.59,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C69.37,87.31,64,86.67,64,86.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M32.54,97.4s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.29,0,1.64,2.57a12.13,12.13,0,0,1,.16,1.3l1.17-.4c-.28-.42-.51-.8-.69-1.13-1.28-2.18-.31-3-.31-3a1.57,1.57,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C37.91,98,32.54,97.4,32.54,97.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M43,93.82s-3.81,3.85-2.58,7.37a2.16,2.16,0,0,0,4.16-.32,1.57,1.57,0,0,0-.8-1.65s1.28.06,1.64,2.57a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.29-.42-.51-.8-.69-1.12-1.29-2.19-.31-3-.31-3a1.54,1.54,0,0,0,.4,1.78A2.15,2.15,0,0,0,49.62,98C48.4,94.46,43,93.82,43,93.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M95.3,76s-3.81,3.85-2.58,7.36A2.17,2.17,0,0,0,96.89,83a1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.57c.06.36.11.8.15,1.31l1.18-.41a12.71,12.71,0,0,1-.7-1.13c-1.28-2.18-.3-3-.3-3a1.56,1.56,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.45-2.34C100.67,76.63,95.3,76,95.3,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M105.79,72.41s-3.81,3.85-2.58,7.37a2.16,2.16,0,0,0,4.16-.32,1.55,1.55,0,0,0-.8-1.64s1.28.05,1.64,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.28-.42-.51-.8-.69-1.12-1.28-2.19-.31-3-.31-3a1.58,1.58,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C111.16,73.05,105.79,72.41,105.79,72.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M74.33,83.15S70.52,87,71.75,90.51a2.16,2.16,0,0,0,4.16-.32,1.55,1.55,0,0,0-.8-1.64s1.28,0,1.64,2.56a12.35,12.35,0,0,1,.16,1.31L78.08,92a12.36,12.36,0,0,1-.69-1.12c-1.28-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C79.7,83.78,74.33,83.15,74.33,83.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M84.81,79.57s-3.8,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31A1.57,1.57,0,0,0,85.59,85s1.29,0,1.65,2.57a12.13,12.13,0,0,1,.16,1.3l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3A1.57,1.57,0,0,0,88,86.07a2.16,2.16,0,0,0,3.45-2.35C90.19,80.21,84.81,79.57,84.81,79.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M61.26,97s-3.8,3.85-2.57,7.37a2.16,2.16,0,0,0,4.16-.32,1.56,1.56,0,0,0-.81-1.64s1.29,0,1.65,2.56a12.35,12.35,0,0,1,.16,1.31L65,105.9a12.36,12.36,0,0,1-.69-1.12c-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C66.64,97.67,61.26,97,61.26,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M71.75,93.46s-3.81,3.84-2.57,7.36a2.16,2.16,0,0,0,2.75,1.33,2.19,2.19,0,0,0,1.41-1.64,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.56a12.69,12.69,0,0,1,.16,1.31l1.17-.4a11.54,11.54,0,0,1-.69-1.13c-1.29-2.19-.31-3-.31-3A1.57,1.57,0,0,0,74.9,100a2.16,2.16,0,0,0,3.45-2.35C77.13,94.09,71.75,93.46,71.75,93.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M40.29,104.19s-3.81,3.84-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.57a12.38,12.38,0,0,1,.15,1.3l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C45.66,104.83,40.29,104.19,40.29,104.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M50.78,100.61S47,104.46,48.2,108A2.16,2.16,0,0,0,51,109.3a2.2,2.2,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.28.06,1.65,2.57c.06.36.11.8.15,1.31l1.17-.41c-.28-.42-.51-.8-.69-1.12-1.28-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.78,2.16,2.16,0,0,0,3.45-2.34C56.15,101.25,50.78,100.61,50.78,100.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M103.05,82.78s-3.81,3.85-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.57a10.14,10.14,0,0,1,.15,1.31l1.18-.41a11.54,11.54,0,0,1-.69-1.13c-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.34C108.43,83.42,103.05,82.78,103.05,82.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M113.54,79.2s-3.81,3.85-2.58,7.37a2.15,2.15,0,0,0,2.75,1.32,2.18,2.18,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.29.06,1.65,2.57c.06.37.11.8.15,1.31l1.18-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.4,1.78,2.16,2.16,0,0,0,3.45-2.34C118.91,79.84,113.54,79.2,113.54,79.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M82.08,89.93s-3.81,3.85-2.58,7.37a2.15,2.15,0,0,0,2.75,1.32A2.18,2.18,0,0,0,83.67,97a1.58,1.58,0,0,0-.81-1.64s1.29,0,1.65,2.56c.06.37.11.8.15,1.31l1.17-.41c-.28-.42-.51-.79-.69-1.12-1.28-2.19-.31-3-.31-3a1.58,1.58,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C87.45,90.57,82.08,89.93,82.08,89.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M92.57,86.36S88.76,90.2,90,93.72a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28,0,1.64,2.56a12.69,12.69,0,0,1,.16,1.31l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C97.94,87,92.57,86.36,92.57,86.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M59.28,107.14s-3.81,3.85-2.58,7.37a2.16,2.16,0,0,0,4.16-.32,1.55,1.55,0,0,0-.8-1.64s1.28,0,1.64,2.56a12.35,12.35,0,0,1,.16,1.31L63,116a12.36,12.36,0,0,1-.69-1.12c-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C64.65,107.78,59.28,107.14,59.28,107.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M69.76,103.57s-3.81,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.81-1.65s1.29,0,1.65,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C75.14,104.2,69.76,103.57,69.76,103.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M38.3,114.3s-3.81,3.84-2.57,7.36A2.16,2.16,0,0,0,38.48,123a2.19,2.19,0,0,0,1.41-1.64,1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.57a12.38,12.38,0,0,1,.15,1.3l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.41,2.17,2.17,0,0,0,1.32-2.76C43.68,114.94,38.3,114.3,38.3,114.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M48.79,110.72s-3.81,3.85-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.6,1.6,0,0,0-.81-1.65s1.29.06,1.65,2.57c.06.36.11.8.15,1.31l1.18-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.34C54.16,111.36,48.79,110.72,48.79,110.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M101.06,92.89s-3.8,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.57a12,12,0,0,1,.16,1.31l1.17-.41c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79A2.16,2.16,0,0,0,107.66,97C106.44,93.53,101.06,92.89,101.06,92.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M111.55,89.31s-3.81,3.85-2.57,7.37A2.14,2.14,0,0,0,111.73,98a2.17,2.17,0,0,0,1.41-1.64,1.6,1.6,0,0,0-.81-1.65s1.29.06,1.65,2.57a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.3-3-.3-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.45-2.34C116.93,90,111.55,89.31,111.55,89.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M80.09,100s-3.81,3.85-2.58,7.37a2.17,2.17,0,0,0,4.17-.32,1.58,1.58,0,0,0-.81-1.64s1.29,0,1.65,2.56a10.36,10.36,0,0,1,.15,1.31l1.18-.41a12.69,12.69,0,0,1-.7-1.12c-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.19,2.19,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C85.46,100.68,80.09,100,80.09,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M90.58,96.47s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,2.75,1.33,2.2,2.2,0,0,0,1.42-1.64,1.58,1.58,0,0,0-.81-1.65s1.28,0,1.64,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.4c-.28-.43-.51-.8-.69-1.13-1.28-2.19-.31-3-.31-3a1.59,1.59,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C96,97.1,90.58,96.47,90.58,96.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M67,113.93s-3.81,3.85-2.58,7.37a2.15,2.15,0,0,0,2.75,1.32A2.18,2.18,0,0,0,68.62,121a1.6,1.6,0,0,0-.81-1.65s1.28.06,1.65,2.57c.06.37.11.8.15,1.31l1.18-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.78,2.16,2.16,0,0,0,3.45-2.34C72.4,114.57,67,113.93,67,113.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M77.52,110.36s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.56,1.56,0,0,0-.8-1.65s1.28,0,1.65,2.56c.06.37.11.8.15,1.31l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.17,2.17,0,0,0,3.46-2.35C82.89,111,77.52,110.36,77.52,110.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M46.05,121.09s-3.8,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28.05,1.64,2.57a12.13,12.13,0,0,1,.16,1.3l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.17,2.17,0,0,0,3.46-2.35C51.43,121.72,46.05,121.09,46.05,121.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M56.54,117.51s-3.8,3.84-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.57a12.13,12.13,0,0,1,.16,1.3l1.17-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.18-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C61.92,118.15,56.54,117.51,56.54,117.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M108.82,99.68s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28,0,1.65,2.57c.06.36.11.8.15,1.3l1.17-.4c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C114.19,100.32,108.82,99.68,108.82,99.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M119.3,96.1s-3.81,3.85-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29.06,1.65,2.57a12,12,0,0,1,.16,1.31l1.17-.41a11.53,11.53,0,0,1-.69-1.12c-1.29-2.19-.31-3-.31-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.46-2.34C124.68,96.74,119.3,96.1,119.3,96.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M87.84,106.83s-3.81,3.85-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29.06,1.65,2.57a12.35,12.35,0,0,1,.16,1.31l1.17-.41a11.53,11.53,0,0,1-.69-1.12c-1.29-2.19-.31-3-.31-3a1.55,1.55,0,0,0,.39,1.78A2.16,2.16,0,0,0,94.44,111C93.22,107.47,87.84,106.83,87.84,106.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M98.33,103.26s-3.81,3.84-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.56a12.61,12.61,0,0,1,.15,1.31l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C103.7,103.89,98.33,103.26,98.33,103.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M65,124s-3.81,3.85-2.58,7.37a2.16,2.16,0,0,0,2.75,1.32,2.18,2.18,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.29.06,1.65,2.57c.06.37.11.8.15,1.31l1.18-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.3-3-.3-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.45-2.34C70.41,124.68,65,124,65,124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M75.53,120.47s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.56,1.56,0,0,0-.8-1.65s1.28,0,1.65,2.56c.06.37.11.8.15,1.31l1.17-.41c-.28-.42-.51-.79-.69-1.12-1.28-2.19-.31-3-.31-3a1.58,1.58,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C80.9,121.1,75.53,120.47,75.53,120.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M44.07,131.2s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.56,1.56,0,0,0-.8-1.65s1.28.05,1.64,2.56a12.69,12.69,0,0,1,.16,1.31l1.17-.4c-.28-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C49.44,131.83,44.07,131.2,44.07,131.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M54.55,127.62S50.75,131.46,52,135a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.57a12,12,0,0,1,.16,1.31l1.17-.41c-.29-.43-.51-.8-.69-1.13-1.29-2.18-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C59.93,128.26,54.55,127.62,54.55,127.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M106.83,109.79s-3.81,3.84-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.57c.06.36.11.8.15,1.3l1.17-.4c-.28-.43-.51-.8-.69-1.13-1.28-2.19-.31-3-.31-3a1.59,1.59,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C112.2,110.43,106.83,109.79,106.83,109.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M117.32,106.21s-3.81,3.85-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28,0,1.64,2.57a12,12,0,0,1,.16,1.31l1.17-.41c-.29-.42-.51-.8-.69-1.12-1.29-2.19-.31-3-.31-3a1.54,1.54,0,0,0,.4,1.78,2.15,2.15,0,0,0,2.12.41,2.18,2.18,0,0,0,1.33-2.76C122.69,106.85,117.32,106.21,117.32,106.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M85.86,116.94s-3.81,3.85-2.58,7.37a2.16,2.16,0,0,0,4.16-.32,1.55,1.55,0,0,0-.81-1.64s1.29.05,1.65,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.29-.42-.51-.8-.69-1.12-1.29-2.19-.31-3-.31-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.46-2.34C91.23,117.58,85.86,116.94,85.86,116.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M96.34,113.37s-3.81,3.84-2.57,7.36a2.16,2.16,0,0,0,2.75,1.33,2.19,2.19,0,0,0,1.41-1.65,1.56,1.56,0,0,0-.81-1.64s1.29,0,1.65,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.41a10.44,10.44,0,0,1-.69-1.12c-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C101.71,114,96.34,113.37,96.34,113.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M72.79,130.83s-3.8,3.85-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.6,1.6,0,0,0-.81-1.65s1.29.06,1.65,2.57a10.14,10.14,0,0,1,.15,1.31l1.18-.41a11.53,11.53,0,0,1-.69-1.12c-1.29-2.19-.31-3-.31-3a1.55,1.55,0,0,0,.39,1.78A2.16,2.16,0,0,0,79.39,135C78.16,131.47,72.79,130.83,72.79,130.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M83.28,127.25s-3.81,3.85-2.58,7.37a2.17,2.17,0,0,0,4.17-.32,1.58,1.58,0,0,0-.81-1.64s1.29.05,1.65,2.56c.06.37.11.8.15,1.31l1.18-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.31-3-.31-3a1.59,1.59,0,0,0,.4,1.79,2.19,2.19,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C88.65,127.89,83.28,127.25,83.28,127.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M51.82,138s-3.81,3.84-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.58,1.58,0,0,0-.81-1.65s1.29.05,1.65,2.56c.06.37.11.8.15,1.31l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.31-3-.31-3a1.59,1.59,0,0,0,.4,1.79,2.19,2.19,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C57.19,138.62,51.82,138,51.82,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M62.31,134.41s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28.05,1.64,2.57a12.13,12.13,0,0,1,.16,1.3l1.17-.4c-.28-.43-.51-.8-.69-1.13-1.28-2.19-.31-3-.31-3a1.58,1.58,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C67.68,135.05,62.31,134.41,62.31,134.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M114.58,116.58s-3.81,3.84-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.56c.06.37.11.81.15,1.31l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C120,117.22,114.58,116.58,114.58,116.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M125.07,113s-3.81,3.85-2.58,7.36a2.16,2.16,0,0,0,2.75,1.33,2.2,2.2,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.28,0,1.65,2.57c.06.36.11.8.15,1.31l1.18-.41c-.29-.43-.52-.8-.7-1.13-1.28-2.18-.31-3-.31-3a1.57,1.57,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C130.44,113.64,125.07,113,125.07,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M93.61,123.73s-3.81,3.85-2.58,7.36a2.16,2.16,0,0,0,4.16-.31,1.57,1.57,0,0,0-.8-1.65s1.28.06,1.65,2.57c.06.37.11.8.15,1.31l1.17-.41c-.28-.42-.51-.8-.69-1.12-1.28-2.19-.31-3-.31-3a1.54,1.54,0,0,0,.4,1.78,2.16,2.16,0,0,0,3.45-2.34C99,124.37,93.61,123.73,93.61,123.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M104.09,120.15s-3.8,3.85-2.57,7.37a2.16,2.16,0,0,0,4.16-.32,1.57,1.57,0,0,0-.8-1.64s1.28,0,1.64,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.41a12.36,12.36,0,0,1-.69-1.12c-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.4,2.16,2.16,0,0,0,1.32-2.75C109.47,120.79,104.09,120.15,104.09,120.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M70.8,140.94s-3.8,3.85-2.57,7.36a2.16,2.16,0,0,0,4.16-.31,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.57a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.29-.42-.51-.8-.69-1.12-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.34C76.18,141.58,70.8,140.94,70.8,140.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M81.29,137.36s-3.81,3.85-2.57,7.37a2.16,2.16,0,0,0,4.16-.32,1.58,1.58,0,0,0-.81-1.64s1.29,0,1.65,2.56a10.36,10.36,0,0,1,.15,1.31l1.18-.41a12.69,12.69,0,0,1-.7-1.12c-1.28-2.19-.3-3-.3-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.45-2.34C86.66,138,81.29,137.36,81.29,137.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M49.83,148.1s-3.81,3.84-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.58,1.58,0,0,0-.81-1.65s1.29.05,1.65,2.56c.06.37.11.8.15,1.31l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.3-3-.3-3A1.57,1.57,0,0,0,53,154.6a2.16,2.16,0,0,0,3.45-2.35C55.2,148.73,49.83,148.1,49.83,148.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M60.32,144.52s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,2.75,1.33,2.2,2.2,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.28.05,1.65,2.57c.06.36.11.8.15,1.3l1.17-.4c-.28-.43-.51-.8-.69-1.13-1.28-2.19-.31-3-.31-3a1.58,1.58,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C65.69,145.16,60.32,144.52,60.32,144.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M112.59,126.69s-3.81,3.84-2.57,7.36a2.16,2.16,0,0,0,2.75,1.33,2.19,2.19,0,0,0,1.41-1.64,1.59,1.59,0,0,0-.81-1.65s1.29,0,1.65,2.56a10.58,10.58,0,0,1,.15,1.31l1.18-.4a11.54,11.54,0,0,1-.69-1.13c-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.35C118,127.32,112.59,126.69,112.59,126.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M123.08,123.11s-3.81,3.85-2.58,7.36a2.17,2.17,0,0,0,4.17-.31,1.6,1.6,0,0,0-.81-1.65s1.29.05,1.65,2.57a12.29,12.29,0,0,1,.15,1.31l1.18-.41c-.29-.43-.52-.8-.7-1.12-1.28-2.2-.31-3-.31-3a1.59,1.59,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C128.45,123.75,123.08,123.11,123.08,123.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M91.62,133.84s-3.81,3.85-2.58,7.36a2.15,2.15,0,0,0,2.75,1.33,2.18,2.18,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.29,0,1.65,2.57c.06.36.11.8.15,1.31l1.18-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.4,1.78A2.16,2.16,0,0,0,98.22,138C97,134.48,91.62,133.84,91.62,133.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M102.11,130.27s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,4.16-.32,1.55,1.55,0,0,0-.8-1.64s1.28.05,1.64,2.56a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.28-.42-.51-.79-.69-1.12-1.29-2.19-.31-3-.31-3a1.56,1.56,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C107.48,130.9,102.11,130.27,102.11,130.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M50.69,62.91s-3.8,3.84-2.57,7.36A2.16,2.16,0,0,0,52.28,70a1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.57a12,12,0,0,1,.16,1.31l1.17-.41c-.29-.43-.51-.8-.69-1.13-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.16,2.16,0,0,0,3.45-2.34C56.07,63.55,50.69,62.91,50.69,62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M61.18,59.33s-3.81,3.85-2.57,7.36A2.14,2.14,0,0,0,61.36,68a2.17,2.17,0,0,0,1.41-1.64A1.6,1.6,0,0,0,62,64.73s1.29.06,1.65,2.57a10.36,10.36,0,0,1,.15,1.31l1.18-.41c-.29-.42-.52-.8-.7-1.12-1.28-2.19-.3-3-.3-3a1.55,1.55,0,0,0,.39,1.78,2.16,2.16,0,0,0,3.45-2.34C66.55,60,61.18,59.33,61.18,59.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M29.72,70.07s-3.81,3.84-2.58,7.36a2.17,2.17,0,0,0,4.17-.32,1.58,1.58,0,0,0-.81-1.64s1.29,0,1.65,2.56c.06.37.11.8.15,1.31l1.18-.41a12.69,12.69,0,0,1-.7-1.12c-1.28-2.19-.3-3-.3-3a1.57,1.57,0,0,0,.39,1.79A2.19,2.19,0,0,0,35,77a2.16,2.16,0,0,0,1.32-2.75C35.09,70.7,29.72,70.07,29.72,70.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M40.21,66.49s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,2.75,1.33,2.2,2.2,0,0,0,1.42-1.64A1.59,1.59,0,0,0,41,71.89s1.28,0,1.64,2.56a12.69,12.69,0,0,1,.16,1.31l1.17-.4c-.28-.43-.51-.8-.69-1.13C42,72,43,71.2,43,71.2a1.58,1.58,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C45.58,67.12,40.21,66.49,40.21,66.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M92.48,48.66S88.67,52.5,89.91,56a2.16,2.16,0,0,0,2.75,1.33,2.19,2.19,0,0,0,1.41-1.64,1.58,1.58,0,0,0-.81-1.65s1.29,0,1.65,2.56a10.58,10.58,0,0,1,.15,1.31l1.18-.4a11.54,11.54,0,0,1-.69-1.13c-1.29-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.39,1.79,2.2,2.2,0,0,0,2.13.4,2.15,2.15,0,0,0,1.32-2.75C97.86,49.29,92.48,48.66,92.48,48.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M103,45.08s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,2.75,1.33,2.2,2.2,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.28.05,1.65,2.57c.06.36.11.8.15,1.3l1.18-.4c-.29-.43-.52-.8-.7-1.13-1.28-2.19-.31-3-.31-3a1.59,1.59,0,0,0,.4,1.79,2.16,2.16,0,0,0,3.45-2.35C108.34,45.72,103,45.08,103,45.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M71.51,55.81s-3.81,3.84-2.58,7.36a2.16,2.16,0,0,0,2.75,1.33,2.2,2.2,0,0,0,1.42-1.64,1.6,1.6,0,0,0-.81-1.65s1.28,0,1.65,2.57c.06.36.11.8.15,1.3l1.17-.4c-.28-.42-.51-.8-.69-1.13-1.28-2.19-.31-3-.31-3a1.57,1.57,0,0,0,.4,1.79A2.16,2.16,0,0,0,78.11,60C76.88,56.45,71.51,55.81,71.51,55.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M82,52.23s-3.8,3.85-2.57,7.37a2.16,2.16,0,0,0,4.16-.32,1.57,1.57,0,0,0-.8-1.65s1.28.06,1.64,2.57a12.35,12.35,0,0,1,.16,1.31l1.17-.41c-.28-.42-.51-.8-.69-1.12-1.29-2.19-.31-3-.31-3a1.54,1.54,0,0,0,.4,1.78,2.16,2.16,0,0,0,3.45-2.34C87.37,52.87,82,52.23,82,52.23Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M81.72,73.81l12.16,2.58s-2.6,10.56-19.62,11S46,74.76,46,74.76l10.61-2s7,6.76,15.33,5.34S81.72,73.81,81.72,73.81Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M72.68,33.6l19.74,1.57-.51,2.19L94.4,51.12l-2.71.72L92.07,55l-2.3,1.47L90,58.21s-2.56,1.06-1.07,2.57,2.8,4.39-4.3,4.79c-4.32.25-6.52,2.26-2.9,8.45,0-.58-1.52,3.71-7.66,4.3-13.2,1.24-17.61-5.59-17.61-5.59S72.34,39.34,72.68,33.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M91.42,37.68a2.29,2.29,0,0,1-1.24,2.92,12,12,0,0,1-2.75-.84c-1.62-.66-5.17-.22-5.65.35s1-3.29,6.62-1.61C91.88,39.53,91.42,37.68,91.42,37.68Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.46,41.09A6,6,0,0,1,87.2,41c-1.62-.55-3.85-.43-4.93.57a9.2,9.2,0,0,1,4.3.28s-.55,2,.66,2.2,1.3-2,1.3-2A3.17,3.17,0,0,0,90.46,41.09Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M75,33.06S73.12,60.37,77.1,62c0,0,3.7,4.65-1.8,7.65-3.43,1.87-5.6,1.46-21.75-1,0,0,0-21.5,1.35-35.54Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "37.86 78.14 80.72 116.57 111.42 119.36 50.98 73.86 37.86 78.14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M75,33.06S72.84,57.61,77.1,62s-2,7.4-4.8,8.9c0,0,7.73-3.9,4.32-8C70.62,55.62,75,33.06,75,33.06Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M92.62,34.62s-13-3.62-38.25-1l.38,1.88s21.77-1.88,37.37.75Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M92.07,55s-4.48-.82-6.35-.07c0,0-2.09,5.67-1.34,6.17l4.51-.28a5.3,5.3,0,0,1,1.73,4.09A12.37,12.37,0,0,1,88.36,66l-4.94.28-.2-4.82,2-7a6.34,6.34,0,0,1,4-1.3,13.16,13.16,0,0,0,2.5-.25Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.86,76S88.74,88.76,68.24,87.24l2.33,1.52s20.21,2.61,23.54-12.43Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "67.62 86.25 52.33 74.77 37.87 111.5 59.12 114.12 67.62 86.25"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "67.62 86.37 59.12 114.25 61 114.25 69.66 87.92 67.62 86.37"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.16 91.42 69.66 87.92 61 114.25 65.83 114.75 74.16 91.42"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M46.91,82.64S44,84.07,44,86.29a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C49.82,84,46.91,82.64,46.91,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M53.51,82.64s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.66.94.94,0,0,0-.14-1.08s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77A1,1,0,0,0,54,86.9a1.29,1.29,0,0,0,2.4-.66C56.41,84,53.51,82.64,53.51,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M33.72,82.64s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.12-.66.94.94,0,0,0-.14-1.08s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C36.62,84,33.72,82.64,33.72,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M40.31,82.64s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C43.22,84,40.31,82.64,40.31,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M73.2,82.64s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.12-.66,1,1,0,0,0-.14-1.08s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C76.1,84,73.2,82.64,73.2,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M79.79,82.64s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C82.7,84,79.79,82.64,79.79,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M60,82.64s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C62.91,84,60,82.64,60,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M66.6,82.64s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62A.94.94,0,0,0,66,85.83s.72.28.44,1.76c0,.22-.09.48-.17.77H67c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C69.51,84,66.6,82.64,66.6,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M43.85,77.32S41,78.75,41,81a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C46.75,78.71,43.85,77.32,43.85,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M50.44,77.32S47.56,78.75,47.58,81a1.27,1.27,0,0,0,1.29,1.28A1.31,1.31,0,0,0,50,81.6a1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76A.93.93,0,0,0,51,81.59a1.28,1.28,0,0,0,2.39-.66C53.35,78.71,50.44,77.32,50.44,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M30.65,77.32S27.77,78.75,27.79,81a1.27,1.27,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C33.56,78.71,30.65,77.32,30.65,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M37.25,77.32S34.37,78.75,34.38,81a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C40.16,78.71,37.25,77.32,37.25,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M70.13,77.32S67.25,78.75,67.27,81a1.27,1.27,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.16.76h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C73,78.71,70.13,77.32,70.13,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M76.73,77.32S73.85,78.75,73.86,81a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C79.64,78.71,76.73,77.32,76.73,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M56.94,77.32S54.06,78.75,54.07,81a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C59.85,78.71,56.94,77.32,56.94,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M63.54,77.32S60.65,78.75,60.67,81A1.28,1.28,0,0,0,62,82.25a1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76H64a6.52,6.52,0,0,1-.17-.77c-.31-1.48.4-1.76.4-1.76a1,1,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C66.44,78.71,63.54,77.32,63.54,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M43.85,88S41,89.38,41,91.6a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C46.75,89.34,43.85,88,43.85,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M50.44,88s-2.88,1.43-2.86,3.65a1.27,1.27,0,0,0,1.29,1.28A1.31,1.31,0,0,0,50,92.23a1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76A.93.93,0,0,0,51,92.22a1.28,1.28,0,0,0,2.39-.66C53.35,89.34,50.44,88,50.44,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M30.65,88s-2.88,1.43-2.86,3.65a1.27,1.27,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C33.56,89.34,30.65,88,30.65,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M37.25,88s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C40.16,89.34,37.25,88,37.25,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M70.13,88s-2.88,1.43-2.86,3.65a1.27,1.27,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.16.76h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C73,89.34,70.13,88,70.13,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M76.73,88s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C79.64,89.34,76.73,88,76.73,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M56.94,88s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C59.85,89.34,56.94,88,56.94,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M63.54,88s-2.89,1.43-2.87,3.65A1.28,1.28,0,0,0,62,92.88a1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76H64a6.52,6.52,0,0,1-.17-.77c-.31-1.48.4-1.76.4-1.76a1,1,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C66.44,89.34,63.54,88,63.54,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M46.91,93.27S44,94.7,44,96.92a1.28,1.28,0,0,0,1.3,1.27,1.27,1.27,0,0,0,1.11-.65.94.94,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.17.77h.74c-.08-.29-.13-.54-.17-.76-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C49.82,94.66,46.91,93.27,46.91,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M53.51,93.27s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77A1,1,0,0,0,54,97.53a1.29,1.29,0,0,0,2.4-.66C56.41,94.66,53.51,93.27,53.51,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M33.72,93.27s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C36.62,94.66,33.72,93.27,33.72,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M40.31,93.27s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C43.22,94.66,40.31,93.27,40.31,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M73.2,93.27s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62,1,1,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C76.1,94.66,73.2,93.27,73.2,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M79.79,93.27s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C82.7,94.66,79.79,93.27,79.79,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M60,93.27s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74a6.22,6.22,0,0,1-.18-.76c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C62.91,94.66,60,93.27,60,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M66.6,93.27s-2.88,1.43-2.87,3.65A1.28,1.28,0,0,0,65,98.19a1.27,1.27,0,0,0,1.11-.65A.94.94,0,0,0,66,96.46s.72.27.44,1.76c0,.22-.09.47-.17.77H67c-.08-.29-.13-.54-.17-.76-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C69.51,94.66,66.6,93.27,66.6,93.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M43.85,98.58S41,100,41,102.23a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C46.75,100,43.85,98.58,43.85,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M50.44,98.58s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C53.35,100,50.44,98.58,50.44,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M30.65,98.58s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C33.56,100,30.65,98.58,30.65,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M37.25,98.58s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C40.16,100,37.25,98.58,37.25,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M70.13,98.58s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.16.76h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C73,100,70.13,98.58,70.13,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M76.73,98.58s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C79.64,100,76.73,98.58,76.73,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M56.94,98.58s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C59.85,100,56.94,98.58,56.94,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M63.54,98.58s-2.89,1.43-2.87,3.65A1.28,1.28,0,0,0,62,103.51a1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76H64a6.52,6.52,0,0,1-.17-.77c-.31-1.48.4-1.76.4-1.76a1,1,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C66.44,100,63.54,98.58,63.54,98.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M46.91,103.9S44,105.33,44,107.55a1.28,1.28,0,0,0,1.3,1.27,1.27,1.27,0,0,0,1.11-.65.94.94,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.17.77h.74c-.08-.29-.13-.54-.17-.76-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C49.82,105.29,46.91,103.9,46.91,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M53.51,103.9s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C56.41,105.29,53.51,103.9,53.51,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M33.72,103.9s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C36.62,105.29,33.72,103.9,33.72,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M40.31,103.9s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C43.22,105.29,40.31,103.9,40.31,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M73.2,103.9s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62,1,1,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C76.1,105.29,73.2,103.9,73.2,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M79.79,103.9s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C82.7,105.29,79.79,103.9,79.79,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M60,103.9s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74a6.22,6.22,0,0,1-.18-.76c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C62.91,105.29,60,103.9,60,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M66.6,103.9s-2.88,1.43-2.87,3.65a1.28,1.28,0,0,0,1.3,1.27,1.27,1.27,0,0,0,1.11-.65.94.94,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.17.77H67c-.08-.29-.13-.54-.17-.76-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C69.51,105.29,66.6,103.9,66.6,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M43.85,109.21S41,110.64,41,112.86a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C46.75,110.6,43.85,109.21,43.85,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M50.44,109.21s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C53.35,110.6,50.44,109.21,50.44,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M30.65,109.21s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C33.56,110.6,30.65,109.21,30.65,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M37.25,109.21s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C40.16,110.6,37.25,109.21,37.25,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M70.13,109.21s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.16.76h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C73,110.6,70.13,109.21,70.13,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M76.73,109.21s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C79.64,110.6,76.73,109.21,76.73,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M56.94,109.21s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C59.85,110.6,56.94,109.21,56.94,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M63.54,109.21s-2.89,1.43-2.87,3.65A1.28,1.28,0,0,0,62,114.14a1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76H64a6.52,6.52,0,0,1-.17-.77c-.31-1.48.4-1.76.4-1.76a1,1,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C66.44,110.6,63.54,109.21,63.54,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M46.91,114.53S44,116,44,118.18a1.28,1.28,0,0,0,1.3,1.27,1.27,1.27,0,0,0,1.11-.65.94.94,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.17.77h.74c-.08-.29-.13-.54-.17-.76-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C49.82,115.92,46.91,114.53,46.91,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M53.51,114.53s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C56.41,115.92,53.51,114.53,53.51,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M33.72,114.53s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a1,1,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C36.62,115.92,33.72,114.53,33.72,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M40.31,114.53s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C43.22,115.92,40.31,114.53,40.31,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M73.2,114.53s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62,1,1,0,0,0-.14-1.08s.71.27.43,1.76a6.27,6.27,0,0,1-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C76.1,115.92,73.2,114.53,73.2,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M79.79,114.53s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74c-.08-.29-.14-.54-.18-.76-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C82.7,115.92,79.79,114.53,79.79,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M60,114.53s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.27.43,1.76c0,.22-.09.47-.16.77h.74a6.22,6.22,0,0,1-.18-.76c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C62.91,115.92,60,114.53,60,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M66.6,114.53s-2.88,1.43-2.87,3.65a1.28,1.28,0,0,0,1.3,1.27,1.27,1.27,0,0,0,1.11-.65.94.94,0,0,0-.14-1.08s.72.27.44,1.76c0,.22-.09.47-.17.77H67c-.08-.29-.13-.54-.17-.76-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C69.51,115.92,66.6,114.53,66.6,114.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M43.85,119.84S41,121.27,41,123.49a1.28,1.28,0,0,0,1.29,1.28,1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C46.75,121.23,43.85,119.84,43.85,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M50.44,119.84s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C53.35,121.23,50.44,119.84,50.44,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M30.65,119.84s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.13-1.09s.71.28.43,1.77c0,.21-.09.47-.16.76h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C33.56,121.23,30.65,119.84,30.65,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M37.25,119.84s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.3-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C40.16,121.23,37.25,119.84,37.25,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M70.13,119.84s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.11-.65.94.94,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.16.76h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.76.41-1.76a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C73,121.23,70.13,119.84,70.13,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M76.73,119.84s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C79.64,121.23,76.73,119.84,76.73,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M56.94,119.84s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,1.3,1.28,1.31,1.31,0,0,0,1.11-.65,1,1,0,0,0-.14-1.09s.72.28.44,1.77c0,.21-.09.47-.17.76h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.76.41-1.76a.92.92,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C59.85,121.23,56.94,119.84,56.94,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M63.54,119.84s-2.89,1.43-2.87,3.65A1.28,1.28,0,0,0,62,124.77a1.32,1.32,0,0,0,1.12-.65,1,1,0,0,0-.14-1.09s.71.28.43,1.77a6.16,6.16,0,0,1-.16.76H64a6.52,6.52,0,0,1-.17-.77c-.31-1.48.4-1.76.4-1.76a1,1,0,0,0-.12,1.08,1.32,1.32,0,0,0,1.12.64,1.3,1.3,0,0,0,1.28-1.3C66.44,121.23,63.54,119.84,63.54,119.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M47.51,72s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.92.92,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.16.77h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.77.41-1.77A.93.93,0,0,0,48,76.27a1.28,1.28,0,0,0,2.39-.66C50.42,73.4,47.51,72,47.51,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M54.11,72s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64A1.29,1.29,0,0,0,57,75.61C57,73.4,54.11,72,54.11,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M34.32,72s-2.88,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74c-.08-.3-.13-.55-.17-.77-.31-1.48.41-1.77.41-1.77a.92.92,0,0,0-.12,1.08,1.27,1.27,0,0,0,1.12.64,1.29,1.29,0,0,0,1.27-1.3C37.23,73.4,34.32,72,34.32,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M40.92,72S38,73.44,38.05,75.66a1.29,1.29,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.12-.66,1,1,0,0,0-.14-1.08s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C43.82,73.4,40.92,72,40.92,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M73.8,72s-2.89,1.43-2.87,3.65a1.29,1.29,0,0,0,2.41.62.94.94,0,0,0-.14-1.08s.72.28.44,1.76c0,.22-.09.48-.17.77h.74A6.52,6.52,0,0,1,74,77c-.31-1.48.41-1.77.41-1.77a.93.93,0,0,0-.13,1.08,1.29,1.29,0,0,0,2.4-.66C76.7,73.4,73.8,72,73.8,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M80.4,72s-2.89,1.43-2.87,3.65a1.28,1.28,0,0,0,1.29,1.28,1.31,1.31,0,0,0,1.12-.66,1,1,0,0,0-.14-1.08s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77h.74c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C83.3,73.4,80.4,72,80.4,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M60.61,72s-2.89,1.43-2.87,3.65A1.28,1.28,0,0,0,59,76.94a1.31,1.31,0,0,0,1.12-.66A1,1,0,0,0,60,75.2s.71.28.43,1.76a5.91,5.91,0,0,1-.16.77H61c-.08-.3-.14-.55-.18-.77-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.29,1.29,0,0,0,2.4-.66C63.51,73.4,60.61,72,60.61,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M67.2,72s-2.88,1.43-2.86,3.65a1.28,1.28,0,0,0,2.4.62.93.93,0,0,0-.13-1.08s.71.28.43,1.76c0,.22-.09.48-.16.77h.74a6.8,6.8,0,0,1-.18-.77c-.3-1.48.41-1.77.41-1.77a.93.93,0,0,0-.12,1.08,1.28,1.28,0,0,0,2.39-.66C70.11,73.4,67.2,72,67.2,72Z"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "74.16 91.21 113.41 120.29 109.3 119.96 73.41 93.37 74.16 91.21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.37,33.62l-2.7-15.73s9,1.75,11.75,7.12c0,0,1.13-6.5,9.75-9.75,0,0,9.63,3.13,10.88,10.63,0,0,3.5-9,11.75-9.25l-3.18,18A127.48,127.48,0,0,0,54.37,33.62Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M93.11,29.9a17.06,17.06,0,0,1-.65,1.62l.67.11,2.28-12.44-.06-.05s-6.84,2-7.65,6.89a2.85,2.85,0,0,0,5,2.28,2.09,2.09,0,0,0,.11-2.42S94.29,26.77,93.11,29.9Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M54.21,30c.17.47.38,1,.65,1.62l-.67.11L51.91,19.31l.06,0s6.85,2,7.65,6.89a2.84,2.84,0,0,1-5,2.27A2,2,0,0,1,54.5,26S53,26.89,54.21,30Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M73.31,17.81s-6.42,3.13-6.42,8.05a2.85,2.85,0,0,0,5.32,1.42,2,2,0,0,0-.28-2.4s1.58.62.93,3.91c-.08.49-.2,1.05-.37,1.7h1.64c-.17-.65-.29-1.21-.38-1.7-.64-3.29.94-3.91.94-3.91a2.07,2.07,0,0,0-.29,2.4,2.86,2.86,0,0,0,5.33-1.42C79.73,20.94,73.31,17.81,73.31,17.81Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M54.75,35.5s-3.7,25.39-1.2,33.14Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M66.55,67.89s-2-23.25.5-32.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M59.55,67.89s-2-23.25.5-32.5Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "57.8 69.39 72.3 70.89 57.05 71.64 57.8 69.39"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.42,72.73l-20,3s-3.83.5-4,10,.32,24.87.32,24.87l5.35.64Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M47.22,84.72a2.17,2.17,0,1,1-2.17-2.16A2.17,2.17,0,0,1,47.22,84.72Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "126.64 21.78 116.67 35.26 93.18 101.46 97.05 101.84 123.55 37.51 126.64 21.78"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M101.41,104.93s-6.82-2.13-8.92-5.06c0,0-2.42-.16-2.44.11s-.15,1.86-.56,2-1.86.44-1.91,1,.22,2.35-.11,2.7-1.18.76-.87,2-.69,2.29-.71,2.57,2.55,3.52,8.06,5.56C94,115.81,99.92,105.76,101.41,104.93Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.88,117.57s4.3-16.26,19.76-22.86l1.42,2,18.86,25.87Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M115.31,98.18S102,105.27,99.1,118.08l-6.22-.51s4.68-16.7,19.76-22.86Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M116.55,99.89s-13.17,8-15,18.83l-3-.33s1.85-12.08,16.76-20.21Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M109.72,102.93s-3.13-3.25-.63-5.87c0,0-3.75,1.25-2.75,5.87a14.77,14.77,0,0,1-9.29-1.09l-3.87-.38A13.43,13.43,0,0,0,109.72,102.93Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M97.09,101.62s2.31,2.81,9.25,1.31c0,0-.81-4.85,2.88-5.79,0,0-3.75.54-3.75,5.1C105.47,102.24,100.09,103.31,97.09,101.62Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M85.44,93.41s4.19-.45,4.47-3.84c0,0,1.46,3.16-2.38,5.87a11.16,11.16,0,0,0,6.52,4.81l2.66,2.06S87.24,103.18,85.44,93.41Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M94.17,100.07s-3.39.62-6.64-4.63c0,0,3.88-3,2.25-5.88,0,0,2,2.64-1.23,5.92C88.55,95.48,91.14,99.47,94.17,100.07Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M124.8,25.89s-19.13,53.75-29,74.25C95.8,100.14,113.05,45,124.8,25.89Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M116.55,99.89s-13.08,7.75-15,18.83l2,.25s3.25-11.5,14.33-17.58Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.88,101.39s-11,5.75-14.33,17.58l.92.17a30.89,30.89,0,0,1,14-17.08Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M98.75,160.25l28.37-5.36s5.62-.53,5.62-7.23V121.94l-99.6-11.52s25.12,37.51,33,44.21c.88.74,4.92,1.63,9.88,2.48C85.62,158.76,98.75,160.25,98.75,160.25Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M109.91,152.59s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.6,1.6,0,0,0,.81,1.65s-1.29-.05-1.65-2.57a10.14,10.14,0,0,1-.15-1.31l-1.18.41a12.38,12.38,0,0,1,.69,1.13c1.29,2.18.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.34C104.53,152,109.91,152.59,109.91,152.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M99.42,156.17s3.81-3.85,2.57-7.37a2.13,2.13,0,0,0-2.74-1.32,2.17,2.17,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57a12.61,12.61,0,0,1-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.78A2.16,2.16,0,0,0,92.82,152C94.05,155.53,99.42,156.17,99.42,156.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M130.88,145.43s3.81-3.84,2.58-7.36a2.17,2.17,0,0,0-4.17.31,1.58,1.58,0,0,0,.81,1.65s-1.29-.05-1.65-2.56c-.06-.37-.11-.8-.15-1.31l-1.18.41a12.69,12.69,0,0,1,.7,1.12c1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C125.51,144.8,130.88,145.43,130.88,145.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M120.39,149s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33A2.2,2.2,0,0,0,118.8,142a1.6,1.6,0,0,0,.81,1.65s-1.28-.05-1.64-2.57a12.13,12.13,0,0,1-.16-1.3l-1.17.4c.28.43.51.8.69,1.13,1.28,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C115,148.38,120.39,149,120.39,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M68.12,166.84s3.81-3.84,2.58-7.36a2.17,2.17,0,0,0-4.17.31,1.59,1.59,0,0,0,.81,1.65s-1.29-.05-1.65-2.56a12.94,12.94,0,0,1-.15-1.31l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C62.75,166.21,68.12,166.84,68.12,166.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M57.63,170.42s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33A2.2,2.2,0,0,0,56,163.37a1.6,1.6,0,0,0,.81,1.65s-1.28-.05-1.65-2.57c-.06-.36-.11-.8-.15-1.3l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.31,3,.31,3a1.59,1.59,0,0,0-.4-1.79A2.16,2.16,0,0,0,51,166.27C52.26,169.78,57.63,170.42,57.63,170.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M89.09,159.69s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.8,1.65s-1.28,0-1.65-2.57c-.06-.36-.11-.8-.15-1.31l-1.17.41c.28.42.51.8.69,1.13,1.28,2.18.31,3,.31,3a1.56,1.56,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.34C83.72,159.05,89.09,159.69,89.09,159.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M78.61,163.27s3.8-3.85,2.57-7.37a2.16,2.16,0,0,0-4.16.32,1.57,1.57,0,0,0,.8,1.65s-1.28-.06-1.64-2.57A12.35,12.35,0,0,1,76,154l-1.17.41c.29.42.51.8.69,1.12,1.29,2.19.31,3,.31,3a1.54,1.54,0,0,0-.4-1.78A2.15,2.15,0,0,0,72,159.11C73.23,162.63,78.61,163.27,78.61,163.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M117.66,159.38s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.18,2.18,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.28-.06-1.65-2.57c-.06-.37-.11-.8-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.3,3,.3,3a1.54,1.54,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.45,2.34C112.29,158.74,117.66,159.38,117.66,159.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M107.17,163s3.81-3.84,2.58-7.36a2.17,2.17,0,0,0-4.17.32,1.58,1.58,0,0,0,.81,1.64s-1.28-.05-1.65-2.56c-.06-.37-.11-.8-.15-1.31l-1.17.41c.28.42.51.79.69,1.12,1.28,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C101.8,162.32,107.17,163,107.17,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M138.63,152.22s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.56,1.56,0,0,0,.8,1.65s-1.28,0-1.64-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C133.26,151.59,138.63,152.22,138.63,152.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M128.15,155.8s3.8-3.84,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29-.05-1.65-2.57a12.13,12.13,0,0,1-.16-1.3l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.41,2.17,2.17,0,0,0-1.32,2.76C122.77,155.16,128.15,155.8,128.15,155.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M75.87,173.63s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.2,2.2,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29,0-1.65-2.56c-.06-.37-.11-.81-.15-1.31l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C70.5,173,75.87,173.63,75.87,173.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M65.38,177.21s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.8,1.65s-1.28-.05-1.64-2.57a12,12,0,0,1-.16-1.31l-1.17.41c.29.43.51.8.69,1.13,1.29,2.18.31,3,.31,3a1.56,1.56,0,0,0-.4-1.78,2.16,2.16,0,0,0-3.45,2.34C60,176.57,65.38,177.21,65.38,177.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M96.84,166.48s3.81-3.85,2.58-7.37a2.16,2.16,0,0,0-4.16.32,1.58,1.58,0,0,0,.81,1.65s-1.29-.05-1.65-2.57a12,12,0,0,1-.16-1.31l-1.17.41c.29.42.51.8.69,1.12,1.29,2.19.31,3,.31,3A1.55,1.55,0,0,0,93.7,160a2.16,2.16,0,0,0-3.46,2.34C91.47,165.84,96.84,166.48,96.84,166.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M86.36,170.06s3.8-3.85,2.57-7.37a2.16,2.16,0,0,0-2.75-1.33A2.2,2.2,0,0,0,84.77,163a1.58,1.58,0,0,0,.81,1.64s-1.29-.05-1.65-2.56a10.36,10.36,0,0,1-.15-1.31l-1.18.41a12.36,12.36,0,0,1,.69,1.12c1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.4,2.16,2.16,0,0,0-1.32,2.75C81,169.42,86.36,170.06,86.36,170.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M111.9,142.48s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.59,1.59,0,0,0,.8,1.65s-1.28-.05-1.64-2.57a12,12,0,0,1-.16-1.31l-1.17.41a12.38,12.38,0,0,1,.69,1.13c1.29,2.18.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C106.53,141.84,111.9,142.48,111.9,142.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M101.41,146.06s3.81-3.85,2.57-7.37a2.16,2.16,0,0,0-4.16.32,1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57a10.36,10.36,0,0,1-.15-1.31l-1.18.41a12.69,12.69,0,0,1,.7,1.12c1.28,2.19.3,3,.3,3a1.55,1.55,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.45,2.34C96,145.42,101.41,146.06,101.41,146.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M132.87,135.32s3.81-3.84,2.58-7.36a2.17,2.17,0,0,0-4.17.32,1.58,1.58,0,0,0,.81,1.64s-1.29,0-1.65-2.56c-.06-.37-.11-.8-.15-1.31l-1.18.41a12.69,12.69,0,0,1,.7,1.12c1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C127.5,134.69,132.87,135.32,132.87,135.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M122.38,138.9s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.2,2.2,0,0,0-1.42,1.64,1.58,1.58,0,0,0,.81,1.65s-1.28-.05-1.65-2.56c-.06-.37-.11-.81-.15-1.31l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C117,138.27,122.38,138.9,122.38,138.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M70.11,156.73s3.8-3.84,2.57-7.36A2.16,2.16,0,0,0,69.93,148a2.19,2.19,0,0,0-1.41,1.64,1.58,1.58,0,0,0,.81,1.65s-1.29-.05-1.65-2.56a10.36,10.36,0,0,1-.15-1.31l-1.18.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C64.73,156.1,70.11,156.73,70.11,156.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M59.62,160.31s3.81-3.84,2.58-7.36a2.17,2.17,0,0,0-4.17.31,1.6,1.6,0,0,0,.81,1.65s-1.29,0-1.65-2.57A10.14,10.14,0,0,1,57,151l-1.18.41c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79A2.16,2.16,0,0,0,53,156.16C54.25,159.67,59.62,160.31,59.62,160.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M91.08,149.58s3.81-3.85,2.58-7.36a2.17,2.17,0,0,0-4.17.31,1.6,1.6,0,0,0,.81,1.65s-1.28-.05-1.65-2.57c-.06-.36-.11-.8-.15-1.31l-1.18.41a12.71,12.71,0,0,1,.7,1.13c1.28,2.19.31,3,.31,3a1.56,1.56,0,0,0-.4-1.78,2.16,2.16,0,0,0-3.45,2.35C85.71,148.94,91.08,149.58,91.08,149.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M80.59,153.16s3.81-3.85,2.58-7.37a2.16,2.16,0,0,0-4.16.32,1.57,1.57,0,0,0,.8,1.65s-1.28-.06-1.64-2.57a12.35,12.35,0,0,1-.16-1.31l-1.17.41c.28.42.51.8.69,1.12,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.4A2.17,2.17,0,0,0,74,149C75.22,152.52,80.59,153.16,80.59,153.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M104.14,135.69s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.8,1.65s-1.28,0-1.65-2.57c-.06-.36-.11-.8-.15-1.3l-1.17.4c.29.43.51.8.69,1.13,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C98.77,135.05,104.14,135.69,104.14,135.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M93.66,139.27s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.8,1.65s-1.28-.05-1.64-2.57a12,12,0,0,1-.16-1.31l-1.17.41c.29.42.51.8.69,1.12,1.29,2.19.31,3,.31,3a1.55,1.55,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.46,2.34C88.28,138.63,93.66,139.27,93.66,139.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M125.12,128.54s3.81-3.85,2.57-7.37a2.16,2.16,0,0,0-4.16.32,1.56,1.56,0,0,0,.81,1.64s-1.29,0-1.65-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.41c.29.42.51.8.69,1.12,1.29,2.19.31,3,.31,3A1.57,1.57,0,0,0,122,122a2.2,2.2,0,0,0-2.13-.4,2.16,2.16,0,0,0-1.32,2.75C119.74,127.9,125.12,128.54,125.12,128.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M114.63,132.11s3.81-3.84,2.57-7.36a2.15,2.15,0,0,0-2.74-1.33,2.18,2.18,0,0,0-1.42,1.64,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79A2.16,2.16,0,0,0,108,128C109.26,131.48,114.63,132.11,114.63,132.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M62.36,149.94s3.8-3.84,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.8,1.65s-1.28,0-1.64-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.56,1.56,0,0,0-.4-1.79,2.18,2.18,0,0,0-2.12-.4,2.15,2.15,0,0,0-1.32,2.75C57,149.31,62.36,149.94,62.36,149.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M51.87,153.52s3.81-3.84,2.57-7.36a2.16,2.16,0,0,0-2.75-1.33,2.19,2.19,0,0,0-1.41,1.64,1.58,1.58,0,0,0,.81,1.65s-1.29-.05-1.65-2.56a12.69,12.69,0,0,1-.16-1.31l-1.17.4a11.54,11.54,0,0,1,.69,1.13c1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.41,2.17,2.17,0,0,0-1.32,2.76C46.49,152.88,51.87,153.52,51.87,153.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M83.33,142.79s3.81-3.85,2.57-7.36a2.15,2.15,0,0,0-2.74-1.33,2.18,2.18,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29,0-1.65-2.57a10.18,10.18,0,0,1-.15-1.3l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C78,142.15,83.33,142.79,83.33,142.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M72.84,146.37s3.81-3.85,2.58-7.36a2.14,2.14,0,0,0-2.75-1.33,2.18,2.18,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.28-.06-1.65-2.57c-.06-.37-.11-.8-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.78,2.16,2.16,0,0,0-3.45,2.34C67.47,145.73,72.84,146.37,72.84,146.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M106.13,125.58s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.2,2.2,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29-.05-1.65-2.57c-.06-.36-.11-.8-.15-1.3l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.55,1.55,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C100.76,124.94,106.13,125.58,106.13,125.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M95.64,129.16s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.8,1.65s-1.28-.06-1.65-2.57c-.06-.37-.11-.8-.15-1.31l-1.17.41c.29.42.51.8.69,1.12,1.28,2.19.31,3,.31,3a1.54,1.54,0,0,0-.4-1.78A2.16,2.16,0,0,0,89,125C90.27,128.52,95.64,129.16,95.64,129.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M127.11,118.43s3.8-3.85,2.57-7.37a2.16,2.16,0,0,0-4.16.32,1.57,1.57,0,0,0,.8,1.65s-1.28-.06-1.64-2.57a12.35,12.35,0,0,1-.16-1.31l-1.17.41c.29.42.51.8.69,1.12,1.29,2.19.31,3,.31,3a1.54,1.54,0,0,0-.4-1.78,2.15,2.15,0,0,0-3.44,2.34C121.73,117.79,127.11,118.43,127.11,118.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M116.62,122s3.8-3.84,2.57-7.36A2.16,2.16,0,0,0,115,115a1.57,1.57,0,0,0,.81,1.65s-1.29,0-1.65-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C111.24,121.37,116.62,122,116.62,122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M64.34,139.83s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.56,1.56,0,0,0,.8,1.65s-1.28-.05-1.65-2.56c-.06-.37-.11-.8-.15-1.31l-1.17.41c.28.42.51.79.69,1.12,1.29,2.19.31,3,.31,3a1.56,1.56,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C59,139.2,64.34,139.83,64.34,139.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M53.86,143.41s3.8-3.84,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.81,1.65s-1.29,0-1.65-2.57a11.82,11.82,0,0,1-.16-1.3l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.56,1.56,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.44,2.35C48.48,142.78,53.86,143.41,53.86,143.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M85.32,132.68s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.57a12,12,0,0,1-.16-1.31l-1.17.41c.29.42.51.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C80,132,85.32,132.68,85.32,132.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M74.83,136.26s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.18,2.18,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57a12.61,12.61,0,0,1-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.3,3,.3,3a1.55,1.55,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.45,2.34C69.46,135.62,74.83,136.26,74.83,136.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M98.38,118.79s3.81-3.84,2.57-7.36a2.15,2.15,0,0,0-2.74-1.33,2.2,2.2,0,0,0-1.42,1.64,1.59,1.59,0,0,0,.81,1.65s-1.29,0-1.65-2.57a12.38,12.38,0,0,1-.15-1.3l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.41,2.17,2.17,0,0,0-1.32,2.76C93,118.15,98.38,118.79,98.38,118.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M87.89,122.37s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.2,2.2,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29,0-1.65-2.57c-.06-.36-.11-.8-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.34C82.52,121.73,87.89,122.37,87.89,122.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M119.35,111.64s3.81-3.85,2.58-7.37a2.16,2.16,0,0,0-4.16.32,1.57,1.57,0,0,0,.8,1.65s-1.29-.06-1.64-2.57a12.35,12.35,0,0,1-.16-1.31l-1.17.41c.28.42.51.8.69,1.12,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.78,2.16,2.16,0,0,0-3.45,2.34C114,111,119.35,111.64,119.35,111.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M108.86,115.21s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.81,1.65s-1.29,0-1.65-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.4,2.17,2.17,0,0,0-1.33,2.75C103.49,114.58,108.86,115.21,108.86,115.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M56.59,133.05s3.81-3.85,2.58-7.37A2.17,2.17,0,0,0,55,126a1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57c-.06-.37-.11-.8-.15-1.31l-1.18.41a12.69,12.69,0,0,1,.7,1.12c1.28,2.19.31,3,.31,3a1.59,1.59,0,0,0-.4-1.79,2.19,2.19,0,0,0-2.13-.4A2.16,2.16,0,0,0,50,128.89C51.22,132.41,56.59,133.05,56.59,133.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M46.1,136.62s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.56,1.56,0,0,0,.8,1.65s-1.28-.05-1.64-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.28.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C40.73,136,46.1,136.62,46.1,136.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M77.56,125.89s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.59,1.59,0,0,0,.8,1.65s-1.28,0-1.64-2.56a12.69,12.69,0,0,1-.16-1.31l-1.17.4c.29.43.51.8.69,1.13,1.28,2.19.31,3,.31,3a1.56,1.56,0,0,0-.4-1.79A2.16,2.16,0,0,0,71,121.74C72.19,125.25,77.56,125.89,77.56,125.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M67.08,129.47s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.57a10.14,10.14,0,0,1-.15-1.31l-1.18.41c.29.43.51.8.69,1.13,1.29,2.18.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.34C61.7,128.83,67.08,129.47,67.08,129.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M100.37,108.68s3.81-3.84,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.57a12.13,12.13,0,0,1-.16-1.3l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C95,108,100.37,108.68,100.37,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M89.88,112.26s3.81-3.85,2.57-7.36a2.16,2.16,0,0,0-2.75-1.33,2.19,2.19,0,0,0-1.41,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29,0-1.65-2.57A12.29,12.29,0,0,1,87.3,103l-1.18.41a12.71,12.71,0,0,1,.7,1.13c1.28,2.18.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C84.51,111.62,89.88,112.26,89.88,112.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M121.34,101.53s3.81-3.85,2.58-7.37a2.16,2.16,0,0,0-2.75-1.32,2.18,2.18,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57c-.06-.37-.11-.8-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.3,3,.3,3a1.54,1.54,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.45,2.34C116,100.89,121.34,101.53,121.34,101.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M110.85,105.1s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.32,1.55,1.55,0,0,0,.8,1.64s-1.28,0-1.64-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.41c.28.42.51.79.69,1.12,1.28,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C105.48,104.47,110.85,105.1,110.85,105.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M58.58,122.94s3.81-3.85,2.58-7.37a2.17,2.17,0,0,0-4.17.32,1.58,1.58,0,0,0,.81,1.64s-1.29,0-1.65-2.56a12.61,12.61,0,0,1-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.4A2.16,2.16,0,0,0,52,118.78C53.2,122.3,58.58,122.94,58.58,122.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M48.09,126.51s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.56,1.56,0,0,0,.8,1.65s-1.28,0-1.65-2.56c-.06-.37-.11-.8-.15-1.31l-1.17.4c.28.43.51.8.69,1.13,1.28,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C42.72,125.88,48.09,126.51,48.09,126.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M79.55,115.78s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.8,1.65s-1.28,0-1.65-2.56c-.06-.37-.11-.81-.15-1.31l-1.17.4c.29.43.51.8.69,1.13,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.79A2.16,2.16,0,0,0,73,111.63C74.18,115.14,79.55,115.78,79.55,115.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M69.07,119.36s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.59,1.59,0,0,0,.8,1.65s-1.28,0-1.64-2.57a12,12,0,0,1-.16-1.31l-1.17.41a12.38,12.38,0,0,1,.69,1.13c1.29,2.18.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.46,2.34C63.69,118.72,69.07,119.36,69.07,119.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M92.61,101.89s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.57,1.57,0,0,0,.81,1.65s-1.29,0-1.65-2.56A12.35,12.35,0,0,1,90,92.62l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.17,2.17,0,0,0-2.13-.4A2.14,2.14,0,0,0,86,97.74C87.24,101.26,92.61,101.89,92.61,101.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M82.13,105.47s3.81-3.84,2.57-7.36A2.16,2.16,0,0,0,82,96.78a2.19,2.19,0,0,0-1.41,1.64,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.57a12.13,12.13,0,0,1-.16-1.3l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3A1.57,1.57,0,0,0,79,99a2.16,2.16,0,0,0-3.45,2.35C76.75,104.83,82.13,105.47,82.13,105.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M113.59,94.74s3.81-3.85,2.57-7.36a2.15,2.15,0,0,0-2.74-1.33A2.18,2.18,0,0,0,112,87.69a1.6,1.6,0,0,0,.81,1.65s-1.29,0-1.65-2.57a12.29,12.29,0,0,1-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79A2.16,2.16,0,0,0,107,90.59C108.21,94.1,113.59,94.74,113.59,94.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M103.1,98.32s3.81-3.85,2.58-7.37a2.15,2.15,0,0,0-2.75-1.32,2.18,2.18,0,0,0-1.42,1.64,1.58,1.58,0,0,0,.81,1.64s-1.29,0-1.65-2.56c-.06-.37-.11-.8-.15-1.31l-1.17.41c.28.42.51.8.69,1.12,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.78,2.16,2.16,0,0,0-3.45,2.34C97.73,97.68,103.1,98.32,103.1,98.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M50.83,116.15s3.8-3.85,2.57-7.37a2.16,2.16,0,0,0-4.16.32,1.58,1.58,0,0,0,.81,1.65s-1.29-.06-1.65-2.57a12.35,12.35,0,0,1-.16-1.31l-1.17.41a11.53,11.53,0,0,1,.69,1.12c1.29,2.19.31,3,.31,3a1.55,1.55,0,0,0-.39-1.78A2.16,2.16,0,0,0,44.23,112C45.45,115.51,50.83,116.15,50.83,116.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M40.34,119.73s3.81-3.85,2.57-7.37A2.15,2.15,0,0,0,40.17,111a2.18,2.18,0,0,0-1.42,1.65,1.58,1.58,0,0,0,.81,1.64s-1.29,0-1.65-2.56a12.61,12.61,0,0,1-.15-1.31l-1.18.41a12.69,12.69,0,0,1,.7,1.12c1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C35,119.09,40.34,119.73,40.34,119.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M71.8,109s3.81-3.84,2.57-7.36a2.15,2.15,0,0,0-2.74-1.33,2.2,2.2,0,0,0-1.42,1.64,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.56a12.61,12.61,0,0,1-.15-1.31l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C66.43,108.36,71.8,109,71.8,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M61.31,112.57s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.2,2.2,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.28,0-1.65-2.57c-.06-.36-.11-.8-.15-1.31l-1.18.41c.29.43.52.8.7,1.13,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C55.94,111.93,61.31,112.57,61.31,112.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M94.6,91.78s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.56,1.56,0,0,0,.8,1.65s-1.28,0-1.64-2.56A12.35,12.35,0,0,1,92,82.51l-1.17.4c.28.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.56,1.56,0,0,0-.4-1.79A2.16,2.16,0,0,0,88,87.63C89.23,91.15,94.6,91.78,94.6,91.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M84.11,95.36s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31A1.58,1.58,0,0,0,83.34,90s-1.29,0-1.65-2.57a12.13,12.13,0,0,1-.16-1.3l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3A1.57,1.57,0,0,0,81,88.86a2.16,2.16,0,0,0-3.46,2.35C78.74,94.72,84.11,95.36,84.11,95.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M115.58,84.63s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.57a12,12,0,0,1-.16-1.31l-1.17.41c.29.43.51.8.69,1.13,1.29,2.18.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79A2.16,2.16,0,0,0,109,80.48C110.2,84,115.58,84.63,115.58,84.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M105.09,88.21s3.81-3.85,2.57-7.37a2.13,2.13,0,0,0-2.74-1.32,2.17,2.17,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57a12.61,12.61,0,0,1-.15-1.31l-1.18.41a12.69,12.69,0,0,1,.7,1.12c1.28,2.19.3,3,.3,3a1.54,1.54,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.45,2.34C99.71,87.57,105.09,88.21,105.09,88.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M52.82,106s3.8-3.85,2.57-7.37a2.16,2.16,0,0,0-4.16.32,1.59,1.59,0,0,0,.8,1.65s-1.28,0-1.65-2.57c-.06-.37-.11-.8-.15-1.31l-1.17.41c.29.42.51.8.69,1.12,1.29,2.19.31,3,.31,3a1.55,1.55,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.46,2.34C47.44,105.4,52.82,106,52.82,106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M42.33,109.61s3.8-3.84,2.57-7.36a2.16,2.16,0,0,0-4.16.32,1.56,1.56,0,0,0,.81,1.64s-1.29,0-1.65-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.4,2.16,2.16,0,0,0-1.32,2.75C37,109,42.33,109.61,42.33,109.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M73.79,98.88S77.6,95,76.36,91.52a2.16,2.16,0,0,0-2.75-1.33,2.19,2.19,0,0,0-1.41,1.64A1.57,1.57,0,0,0,73,93.48s-1.29,0-1.65-2.56a12.69,12.69,0,0,1-.16-1.31L70,90c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.35C68.42,98.25,73.79,98.88,73.79,98.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M63.3,102.46s3.81-3.85,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.2,2.2,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29,0-1.65-2.57c-.06-.36-.11-.8-.15-1.3l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.3,3,.3,3A1.57,1.57,0,0,0,60.15,96a2.16,2.16,0,0,0-3.45,2.35C57.93,101.82,63.3,102.46,63.3,102.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M114.71,169.81s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-4.16.31,1.55,1.55,0,0,0,.81,1.65s-1.29,0-1.65-2.56a12.35,12.35,0,0,1-.16-1.31l-1.17.4c.28.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.56,1.56,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C109.34,169.18,114.71,169.81,114.71,169.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M104.23,173.39s3.8-3.84,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29-.05-1.65-2.57a12.13,12.13,0,0,1-.16-1.3l-1.17.4c.29.43.51.8.69,1.13,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.2,2.2,0,0,0-2.13-.41,2.18,2.18,0,0,0-1.33,2.76C98.85,172.75,104.23,173.39,104.23,173.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M135.69,162.66s3.8-3.84,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.57a10.14,10.14,0,0,1-.15-1.31l-1.18.41a11.54,11.54,0,0,1,.69,1.13c1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.34C130.31,162,135.69,162.66,135.69,162.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M125.2,166.24s3.81-3.85,2.58-7.36a2.15,2.15,0,0,0-2.75-1.33,2.18,2.18,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57a10.36,10.36,0,0,1-.15-1.31l-1.18.41c.29.42.52.8.7,1.12,1.28,2.19.31,3,.31,3a1.57,1.57,0,0,0-.4-1.78,2.16,2.16,0,0,0-3.45,2.34C119.83,165.6,125.2,166.24,125.2,166.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M72.93,184.07s3.8-3.85,2.57-7.36a2.16,2.16,0,0,0-4.16.31,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.57a12.35,12.35,0,0,1-.16-1.31l-1.17.41c.29.42.51.8.69,1.12,1.29,2.19.31,3,.31,3a1.57,1.57,0,0,0-.39-1.79,2.16,2.16,0,0,0-3.45,2.34C67.55,183.43,72.93,184.07,72.93,184.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M62.44,187.65s3.81-3.85,2.57-7.37a2.16,2.16,0,0,0-4.16.32,1.6,1.6,0,0,0,.81,1.65s-1.29-.06-1.65-2.57a12.61,12.61,0,0,1-.15-1.31l-1.18.41a11.53,11.53,0,0,1,.69,1.12c1.29,2.19.31,3,.31,3a1.55,1.55,0,0,0-.39-1.78,2.16,2.16,0,0,0-3.45,2.34C57.06,187,62.44,187.65,62.44,187.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M93.9,176.91s3.81-3.84,2.57-7.36a2.15,2.15,0,0,0-2.74-1.33,2.18,2.18,0,0,0-1.42,1.64,1.58,1.58,0,0,0,.81,1.65s-1.29,0-1.65-2.56a10.36,10.36,0,0,1-.15-1.31l-1.18.41a12.69,12.69,0,0,1,.7,1.12c1.28,2.19.3,3,.3,3a1.57,1.57,0,0,0-.39-1.79,2.19,2.19,0,0,0-2.13-.4,2.16,2.16,0,0,0-1.32,2.75C88.53,176.28,93.9,176.91,93.9,176.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M83.41,180.49s3.81-3.84,2.58-7.36a2.16,2.16,0,0,0-2.75-1.33,2.2,2.2,0,0,0-1.42,1.64,1.6,1.6,0,0,0,.81,1.65S81.35,175,81,172.52c-.06-.36-.11-.8-.15-1.3l-1.18.4c.29.43.52.8.7,1.13,1.28,2.19.31,3,.31,3a1.58,1.58,0,0,0-.4-1.79,2.16,2.16,0,0,0-3.45,2.35C78,179.86,83.41,180.49,83.41,180.49Z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M83.69,158.92l-12.16-2.58s2.59-10.56,19.62-11S119.38,158,119.38,158l-10.6,2s-7-6.76-15.33-5.33S83.69,158.92,83.69,158.92Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M92.72,199.12,73,197.55l.52-2.18L71,181.61l2.71-.72-.38-3.13,2.3-1.47-.19-1.77s2.56-1.07,1.07-2.58-2.8-4.39,4.29-4.79c4.33-.24,6.53-2.26,2.91-8.44,0,.57,1.52-3.72,7.66-4.3C104.58,153.16,109,160,109,160S93.06,193.38,92.72,199.12Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M74,195a2.28,2.28,0,0,1,1.23-2.91A12.4,12.4,0,0,1,78,193c1.62.67,5.16.23,5.65-.35s-1,3.29-6.63,1.62C73.53,193.2,74,195,74,195Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,191.63a6.1,6.1,0,0,1,3.26.08c1.61.55,3.85.43,4.92-.57a9.09,9.09,0,0,1-4.29-.27s.55-2-.67-2.21-1.29,2-1.29,2A3.17,3.17,0,0,0,75,191.63Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M90.4,199.66s1.89-27.31-2.1-28.93c0,0-3.69-4.64,1.81-7.64,3.43-1.87,5.59-1.47,21.75,1,0,0,0,21.5-1.35,35.54Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "127.55 154.59 84.69 116.16 53.99 113.36 114.42 158.87 127.55 154.59"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M90.4,199.66s2.17-24.55-2.1-28.93,2.06-7.39,4.81-8.89c0,0-7.74,3.89-4.32,8C94.79,177.1,90.4,199.66,90.4,199.66Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M72.79,198.1s13,3.63,38.25,1l-.38-1.87s-21.77,1.87-37.37-.75Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M73.34,177.76s4.48.83,6.35.08c0,0,2.09-5.67,1.34-6.17l-4.51.27a5.3,5.3,0,0,1-1.73-4.09,12,12,0,0,1,2.26-1.11l4.93-.28.21,4.83-2,7a6.3,6.3,0,0,1-4,1.3,13.16,13.16,0,0,0-2.5.25Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.55,156.74S76.67,144,97.17,145.48L94.84,144S74.63,141.35,71.3,156.4Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "97.79 146.48 113.08 157.96 127.54 121.23 106.29 118.6 97.79 146.48"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "97.79 146.35 106.29 118.48 104.41 118.48 95.74 144.81 97.79 146.35"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.24 141.31 95.74 144.81 104.41 118.48 99.58 117.98 91.24 141.31"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M118.5,150.09s2.88-1.44,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.16-.76h-.74a6.33,6.33,0,0,1,.18.77c.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C115.59,148.7,118.5,150.09,118.5,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M111.9,150.09s2.88-1.44,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.29.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C109,148.7,111.9,150.09,111.9,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M131.69,150.09s2.88-1.44,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.29.13.55.17.77.31,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C128.78,148.7,131.69,150.09,131.69,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M125.09,150.09s2.89-1.44,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a1,1,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C122.19,148.7,125.09,150.09,125.09,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M92.21,150.09s2.89-1.44,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76H91.8a6.12,6.12,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.13-.64,1.29,1.29,0,0,0-1.27,1.3C89.3,148.7,92.21,150.09,92.21,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M85.61,150.09s2.89-1.44,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76H85.2c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C82.71,148.7,85.61,150.09,85.61,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M105.4,150.09s2.89-1.44,2.87-3.65a1.27,1.27,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76H105c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C102.5,148.7,105.4,150.09,105.4,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M98.81,150.09s2.88-1.44,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65,1,1,0,0,0,.13,1.09s-.71-.28-.43-1.77c0-.22.09-.47.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C95.9,148.7,98.81,150.09,98.81,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M121.56,155.4s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.71-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.27,1.27,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.27,1.3C118.66,154,121.56,155.4,121.56,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M115,155.4s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.71-.27-.43-1.76a6.27,6.27,0,0,1,.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C112.06,154,115,155.4,115,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M134.75,155.4s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C131.85,154,134.75,155.4,134.75,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M128.16,155.4S131,154,131,151.75a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C125.25,154,128.16,155.4,128.16,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M95.28,155.4s2.88-1.43,2.86-3.65a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C92.37,154,95.28,155.4,95.28,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M88.68,155.4s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C85.77,154,88.68,155.4,88.68,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M108.47,155.4s2.88-1.43,2.86-3.65a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74a6.22,6.22,0,0,1,.18.76c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C105.56,154,108.47,155.4,108.47,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M101.87,155.4s2.88-1.43,2.87-3.65a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.66C99,154,101.87,155.4,101.87,155.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M121.56,144.78s2.89-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.71-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.27,1.27,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.27,1.3C118.66,143.38,121.56,144.78,121.56,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M115,144.78s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.71-.27-.43-1.76a6.27,6.27,0,0,1,.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C112.06,143.38,115,144.78,115,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M134.75,144.78s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C131.85,143.38,134.75,144.78,134.75,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M128.16,144.78s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C125.25,143.38,128.16,144.78,128.16,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M95.28,144.78s2.88-1.44,2.86-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C92.37,143.38,95.28,144.78,95.28,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M88.68,144.78s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C85.77,143.38,88.68,144.78,88.68,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M108.47,144.78s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74a6.22,6.22,0,0,1,.18.76c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C105.56,143.38,108.47,144.78,108.47,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M101.87,144.78s2.88-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.66C99,143.38,101.87,144.78,101.87,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M118.5,139.46s2.88-1.43,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.16-.76h-.74a6.33,6.33,0,0,1,.18.77c.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C115.59,138.07,118.5,139.46,118.5,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M111.9,139.46s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.29.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C109,138.07,111.9,139.46,111.9,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M131.69,139.46s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.29.13.55.17.77.31,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C128.78,138.07,131.69,139.46,131.69,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M125.09,139.46S128,138,128,135.81a1.28,1.28,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a1,1,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C122.19,138.07,125.09,139.46,125.09,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M92.21,139.46s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76H91.8a6.12,6.12,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.13-.64,1.29,1.29,0,0,0-1.27,1.3C89.3,138.07,92.21,139.46,92.21,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M85.61,139.46s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76H85.2c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C82.71,138.07,85.61,139.46,85.61,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M105.4,139.46s2.89-1.43,2.87-3.65a1.27,1.27,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76H105c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C102.5,138.07,105.4,139.46,105.4,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M98.81,139.46s2.88-1.43,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65,1,1,0,0,0,.13,1.09s-.71-.28-.43-1.77c0-.22.09-.47.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C95.9,138.07,98.81,139.46,98.81,139.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M121.56,134.15s2.89-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.71-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.27,1.27,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.27,1.3C118.66,132.75,121.56,134.15,121.56,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M115,134.15s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.71-.27-.43-1.76a6.27,6.27,0,0,1,.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C112.06,132.75,115,134.15,115,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M134.75,134.15s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C131.85,132.75,134.75,134.15,134.75,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M128.16,134.15s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C125.25,132.75,128.16,134.15,128.16,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M95.28,134.15s2.88-1.44,2.86-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C92.37,132.75,95.28,134.15,95.28,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M88.68,134.15s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C85.77,132.75,88.68,134.15,88.68,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M108.47,134.15s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74a6.22,6.22,0,0,1,.18.76c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C105.56,132.75,108.47,134.15,108.47,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M101.87,134.15s2.88-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.66C99,132.75,101.87,134.15,101.87,134.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M118.5,128.83s2.88-1.43,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.16-.76h-.74a6.33,6.33,0,0,1,.18.77c.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C115.59,127.44,118.5,128.83,118.5,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M111.9,128.83s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.29.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C109,127.44,111.9,128.83,111.9,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M131.69,128.83s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.29.13.55.17.77.31,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C128.78,127.44,131.69,128.83,131.69,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M125.09,128.83s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a1,1,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C122.19,127.44,125.09,128.83,125.09,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M92.21,128.83s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76H91.8a6.12,6.12,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.13-.64,1.29,1.29,0,0,0-1.27,1.3C89.3,127.44,92.21,128.83,92.21,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M85.61,128.83s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76H85.2c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C82.71,127.44,85.61,128.83,85.61,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M105.4,128.83s2.89-1.43,2.87-3.65A1.27,1.27,0,0,0,107,123.9a1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76H105c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C102.5,127.44,105.4,128.83,105.4,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M98.81,128.83s2.88-1.43,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65,1,1,0,0,0,.13,1.09s-.71-.28-.43-1.77c0-.22.09-.47.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C95.9,127.44,98.81,128.83,98.81,128.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M121.56,123.52s2.89-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.71-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.27,1.27,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.27,1.3C118.66,122.12,121.56,123.52,121.56,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M115,123.52s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.71-.27-.43-1.76a6.27,6.27,0,0,1,.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C112.06,122.12,115,123.52,115,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M134.75,123.52s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C131.85,122.12,134.75,123.52,134.75,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M128.16,123.52s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C125.25,122.12,128.16,123.52,128.16,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M95.28,123.52s2.88-1.44,2.86-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C92.37,122.12,95.28,123.52,95.28,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M88.68,123.52s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C85.77,122.12,88.68,123.52,88.68,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M108.47,123.52s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74a6.22,6.22,0,0,1,.18.76c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C105.56,122.12,108.47,123.52,108.47,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M101.87,123.52s2.88-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.66C99,122.12,101.87,123.52,101.87,123.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M118.5,118.2s2.88-1.43,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.31,1.31,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.21.09-.47.16-.76h-.74a6.8,6.8,0,0,1,.18.77c.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C115.59,116.81,118.5,118.2,118.5,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M111.9,118.2s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-1.3-1.28,1.31,1.31,0,0,0-1.11.65,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.21.09-.47.17-.76h-.74c.08.3.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C109,116.81,111.9,118.2,111.9,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M131.69,118.2s2.88-1.43,2.87-3.65a1.29,1.29,0,0,0-1.3-1.28,1.31,1.31,0,0,0-1.11.65,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.21.09-.47.17-.76h-.74c.08.3.13.55.17.77.31,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C128.78,116.81,131.69,118.2,131.69,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M125.09,118.2s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a6.16,6.16,0,0,1,.16-.76h-.74c.08.3.14.55.18.77.3,1.48-.41,1.76-.41,1.76a1,1,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C122.19,116.81,125.09,118.2,125.09,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M92.21,118.2s2.89-1.43,2.87-3.65a1.29,1.29,0,0,0-1.3-1.28,1.31,1.31,0,0,0-1.11.65,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.21.09-.47.17-.76H91.8a6.52,6.52,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.13-.64,1.29,1.29,0,0,0-1.27,1.3C89.3,116.81,92.21,118.2,92.21,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M85.61,118.2s2.89-1.43,2.87-3.65a1.28,1.28,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a6.16,6.16,0,0,1,.16-.76H85.2c.08.3.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C82.71,116.81,85.61,118.2,85.61,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M105.4,118.2s2.89-1.43,2.87-3.65a1.27,1.27,0,0,0-1.29-1.28,1.32,1.32,0,0,0-1.12.65A1,1,0,0,0,106,115s-.71-.28-.43-1.77a6.16,6.16,0,0,1,.16-.76H105c.08.3.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C102.5,116.81,105.4,118.2,105.4,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M98.81,118.2s2.88-1.43,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.31,1.31,0,0,0-1.11.65A1,1,0,0,0,99.4,115s-.71-.28-.43-1.77c0-.21.09-.47.16-.76h-.74c.08.3.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C95.9,116.81,98.81,118.2,98.81,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M121.56,112.89s2.89-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.71-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.27,1.27,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.27,1.3C118.66,111.49,121.56,112.89,121.56,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M115,112.89s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62.94.94,0,0,0,.14,1.08s-.71-.27-.43-1.76a6.27,6.27,0,0,1,.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C112.06,111.49,115,112.89,115,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M134.75,112.89s2.89-1.44,2.87-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C131.85,111.49,134.75,112.89,134.75,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M128.16,112.89s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C125.25,111.49,128.16,112.89,128.16,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M95.28,112.89s2.88-1.44,2.86-3.66a1.29,1.29,0,0,0-2.41-.62,1,1,0,0,0,.14,1.08s-.71-.27-.43-1.76c0-.22.09-.47.16-.77h-.74c.08.29.14.54.18.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C92.37,111.49,95.28,112.89,95.28,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M88.68,112.89s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.73c.08.29.13.54.17.76.3,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C85.77,111.49,88.68,112.89,88.68,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M108.47,112.89s2.88-1.44,2.86-3.66a1.28,1.28,0,0,0-2.4-.62.92.92,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.16-.77h-.74a6.22,6.22,0,0,1,.18.76c.3,1.48-.41,1.77-.41,1.77a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C105.56,111.49,108.47,112.89,108.47,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M101.87,112.89s2.88-1.44,2.87-3.66a1.28,1.28,0,0,0-1.3-1.27,1.27,1.27,0,0,0-1.11.65.94.94,0,0,0,.14,1.08s-.72-.27-.44-1.76c0-.22.09-.47.17-.77h-.74c.08.29.13.54.17.76.31,1.48-.41,1.77-.41,1.77a.93.93,0,0,0,.13-1.08,1.29,1.29,0,0,0-2.4.66C99,111.49,101.87,112.89,101.87,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M117.89,160.72s2.89-1.44,2.87-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65,1,1,0,0,0,.13,1.09s-.71-.28-.43-1.77c0-.22.09-.47.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.29,1.29,0,0,0-2.4.66C115,159.33,117.89,160.72,117.89,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M111.3,160.72s2.88-1.44,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.16-.76h-.74a6.33,6.33,0,0,1,.18.77c.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C108.39,159.33,111.3,160.72,111.3,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M131.09,160.72s2.88-1.44,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77a6,6,0,0,1,.17-.76h-.74c.08.29.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C128.18,159.33,131.09,160.72,131.09,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M124.49,160.72s2.88-1.44,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76h-.74c.08.29.13.55.17.77.31,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C121.59,159.33,124.49,160.72,124.49,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M91.61,160.72s2.88-1.44,2.86-3.65a1.27,1.27,0,0,0-1.29-1.28,1.29,1.29,0,0,0-1.11.65.94.94,0,0,0,.14,1.09s-.72-.28-.44-1.77a6,6,0,0,1,.17-.76H91.2c.08.29.13.55.17.77.3,1.48-.41,1.76-.41,1.76a.92.92,0,0,0,.12-1.08,1.28,1.28,0,0,0-2.39.66C88.7,159.33,91.61,160.72,91.61,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M85,160.72s2.89-1.44,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.72-.28-.44-1.77c0-.22.09-.47.17-.76H84.6a6.12,6.12,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.13-.64,1.29,1.29,0,0,0-1.27,1.3C82.11,159.33,85,160.72,85,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M104.8,160.72s2.89-1.44,2.87-3.65a1.29,1.29,0,0,0-2.41-.63,1,1,0,0,0,.14,1.09s-.71-.28-.44-1.77c0-.22.09-.47.17-.76h-.74a6.12,6.12,0,0,1,.17.77c.31,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.13-1.08,1.32,1.32,0,0,0-1.12-.64,1.29,1.29,0,0,0-1.28,1.3C101.9,159.33,104.8,160.72,104.8,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M98.2,160.72s2.89-1.44,2.87-3.65a1.27,1.27,0,0,0-1.29-1.28,1.3,1.3,0,0,0-1.12.65,1,1,0,0,0,.14,1.09s-.71-.28-.43-1.77a5.8,5.8,0,0,1,.16-.76h-.74c.08.29.14.55.18.77.3,1.48-.41,1.76-.41,1.76a.93.93,0,0,0,.12-1.08,1.32,1.32,0,0,0-1.12-.64,1.3,1.3,0,0,0-1.28,1.3C95.3,159.33,98.2,160.72,98.2,160.72Z"
  }))), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "91.24 141.52 51.99 112.43 56.11 112.77 91.99 139.35 91.24 141.52"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111,199.1l2.69,15.74s-9-1.75-11.75-7.13c0,0-1.12,6.5-9.75,9.75,0,0-9.62-3.12-10.87-10.62,0,0-3.5,9-11.75,9.25l3.18-18A127.48,127.48,0,0,0,111,199.1Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M72.3,202.82c.16-.47.37-1,.65-1.62l-.67-.11L70,213.54l.07,0s6.84-2,7.65-6.89a2.85,2.85,0,0,0-5-2.27,2.06,2.06,0,0,0-.11,2.41S71.12,206,72.3,202.82Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M111.19,202.7a17.06,17.06,0,0,0-.65-1.62l.67-.11,2.29,12.44-.06.05s-6.85-2-7.66-6.89a2.86,2.86,0,0,1,5-2.28,2.07,2.07,0,0,1,.11,2.42S112.37,205.83,111.19,202.7Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M92.1,214.92s6.42-3.14,6.42-8a2.86,2.86,0,0,0-5.33-1.43,2.08,2.08,0,0,0,.29,2.41s-1.59-.63-.94-3.91c.08-.49.21-1.06.38-1.71H91.28c.17.65.29,1.22.37,1.71.65,3.28-.93,3.91-.93,3.91a2.08,2.08,0,0,0,.28-2.41,2.85,2.85,0,0,0-5.32,1.43C85.68,211.78,92.1,214.92,92.1,214.92Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M110.66,197.23s3.7-25.39,1.2-33.14Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M98.86,164.84s2,23.25-.5,32.5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M105.86,164.84s2,23.25-.5,32.5Z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "107.61 163.34 93.11 161.84 108.36 161.09 107.61 163.34"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109,160l20-3s3.83-.5,4-10-.33-24.87-.33-24.87l-5.34-.63Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M118.19,148a2.17,2.17,0,1,1,2.17,2.17A2.17,2.17,0,0,1,118.19,148Z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-351",
    points: "38.77 210.95 48.73 197.46 72.23 131.26 68.36 130.89 41.86 195.21 38.77 210.95"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M64,127.8s6.82,2.12,8.91,5.06c0,0,2.42.16,2.45-.12s.15-1.86.56-2,1.86-.44,1.91-1-.22-2.34.11-2.69,1.17-.77.87-2,.69-2.28.71-2.56S77,119,71.45,116.91C71.45,116.91,65.48,127,64,127.8Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.53,115.15S68.23,131.42,52.77,138l-1.42-2L32.49,110.19Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M50.1,134.54s13.33-7.08,16.21-19.89l6.22.5S67.85,131.85,52.77,138Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M48.86,132.83s13.16-8,15-18.83l3,.33S65,126.42,50.1,134.54Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M55.69,129.79s3.13,3.25.63,5.88c0,0,3.75-1.25,2.75-5.88a14.74,14.74,0,0,1,9.29,1.1l3.87.37A13.43,13.43,0,0,0,55.69,129.79Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M68.32,131.11s-2.32-2.82-9.25-1.32c0,0,.81,4.86-2.88,5.8,0,0,3.75-.55,3.75-5.11C59.94,130.48,65.32,129.42,68.32,131.11Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M80,139.31s-4.2.45-4.48,3.84c0,0-1.45-3.15,2.39-5.87a11.16,11.16,0,0,0-6.52-4.81l-2.66-2.06S78.17,129.55,80,139.31Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M71.23,132.66s3.4-.63,6.65,4.62c0,0-3.88,3-2.25,5.89,0,0-1.95-2.65,1.23-5.92C76.86,137.25,74.27,133.25,71.23,132.66Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M40.61,206.84s19.12-53.75,29-74.25C69.61,132.59,52.36,187.71,40.61,206.84Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M48.86,132.83s13.08-7.75,15-18.83l-2-.25s-3.25,11.5-14.33,17.59Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.53,131.34s11-5.75,14.33-17.59l-.92-.16a30.92,30.92,0,0,1-14,17.08Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13S);
export default __webpack_public_path__ + "static/media/13_s.c513410723a6ac25d70930621a4a70cb.svg";
export { ForwardRef as ReactComponent };